export default {
    zh: {
        // 视频特效列表展示
        listTitle: 'AI 舞蹈视频生成器',
        listDesc: '让任意照片随韵律舞动',
        
        // 页面标题与描述
        title: 'AI 舞蹈视频生成器',
        description: '上传照片，选择舞蹈模板和类型，让AI为您生成精彩的跳舞视频',
        
        // 模板预览区域
        templatePreview: '模板预览',
        noTemplateSelected: '请选择一个舞蹈类型查看模板',
        
        // 类型区域
        typesTitle: '选择舞蹈类型',
        
        // 上传区域
        uploadTitle: '上传图片',
        uploadHint: '上传清晰的人物照片，效果更佳',
        
        // 音频开关
        generateAudioLabel: '生成音频',
        
        // 按钮文本
        generateButton: '生成',
        generating: '生成中...',
        
        // 验证提示
        validation: {
            selectType: '请选择舞蹈类型',
            uploadImage: '请上传图片',
            loginRequired: '请先登录',
        },
        
        // 功能提示
        featureComingSoon: 'AI Dancing 功能即将上线，敬请期待！',
        processingHint: '正在生成您的跳舞视频，请稍候...',

        // 底部介绍区域
        introduce: {
            title: 'AI 舞蹈视频生成器',
            desc: '让任意照片随韵律舞动',
        },
        selectReason: {
            title: '为什么选择 WeryAI 舞蹈视频生成器？',
            items: [
                {
                    title: '一张照片，瞬间"出道"',
                    desc: '无需昂贵的动作捕捉设备，也不用学习复杂的 3D 动画。只需一张全身照片，WeryAI 强大的骨骼绑定与重绘技术就能自动识别人物关节，生成流畅自然的舞蹈动作。哪怕是没有任何舞蹈基础的你，也能在视频中化身顶级舞者。',
                },
                {
                    title: '海量舞步，紧跟潮流',
                    desc: '我们的库中收录了数百种热门舞蹈模板，并持续更新。从 K-pop 偶像编舞、街舞 (Hip-hop)、鬼步舞 (Shuffle) 到各种网络爆款 Meme 舞蹈（如科目三等），你想跳什么，AI 就帮你跳什么。',
                },
                {
                    title: '万物皆可舞，创意无边界',
                    desc: '舞蹈不只是人类的专利！你可以上传动漫角色、雕塑、玩具公仔甚至是你家宠物的照片。WeryAI 能智能适配非人类的身体结构，制作出令人捧腹大笑或惊叹不已的创意舞蹈视频，是制作病毒式社交内容的绝佳工具。',
                },
                {
                    title: '动作精准，细节逼真',
                    desc: '担心动作僵硬或脸部崩坏？WeryAI 采用先进的动作迁移算法，在保持大幅度肢体运动的同时，完美锁定人物的面部特征和服装细节。无论舞蹈动作多么激烈，主角依然是你，绝无违和感。',
                },
            ]
        },
        howToUse: {
            title: '如何使用我们的 AI 舞蹈视频生成器？',
            desc: '三步，让你的照片跳起来',
            steps: [
                {
                    title: '步骤 1 上传照片',
                    desc: '选择一张清晰的全身照片（人物、动漫或拟人化动物均可），正面站立效果最佳。',
                },
                {
                    title: '第 2 步 选择模式',
                    desc: '浏览并选择您喜欢的舞蹈模板（支持按风格、热门程度筛选）。',
                },
                {
                    title: '步骤3 生成视频',
                    desc: '点击生成，AI 将自动提取骨骼并进行动作迁移，几秒钟后，属于你的专属舞蹈视频就诞生了！',
                },
            ]
        },
        exploreOthers: {
            title: '探索 WeryAI 的其他热门视频特效',
            items: {
                kissing: 'AI 亲吻视频',
                faceSwap: 'AI 视频换脸',
                anime: 'AI 视频动漫转换器',
            },
        },
        faq: {
            title: '常见问题解答',
            items: [
                {
                    question: '什么是 AI 舞蹈视频生成器？',
                    answer: '它是一款利用人工智能技术（主要是姿态估计和动作迁移技术），将静态的全身照片转化为动态舞蹈视频的工具。用户无需拍摄视频，仅凭一张图就能生成拥有专业舞技的视频内容。',
                },
                {
                    question: '制作舞蹈视频需要什么样的照片？',
                    answer: '为了获得最佳效果，我们建议上传全身可见、光线充足、无大面积遮挡的正面站立照片。虽然半身照也能处理，但全身照能让腿部和脚步动作展现得更加完美。',
                },
                {
                    question: '我可以上传自己的舞蹈视频作为参考吗？',
                    answer: '目前我们主要提供丰富的预设模板。在未来的版本中，我们将开放"视频转视频 (Video to Video)"功能，允许您上传参考视频，让照片中的人物模仿特定的动作。',
                },
                {
                    question: '我可以免费生成 AI 舞蹈视频吗？',
                    answer: '是的！我们为注册用户提供免费积分，让每位用户都能体验并生成 AI 舞蹈视频。对于希望去除水印或获取 4K 超清画质的用户，我们也提供灵活的升级选项。',
                },
                {
                    question: '这个工具安全吗？我的照片会被公开吗？',
                    answer: '绝对安全。我们严格保护您的隐私。您上传的照片和生成的视频仅用于您的创作过程，处理完成后会在规定时间内从服务器彻底删除，绝不会用于任何商业用途或公开展示。',
                },
                {
                    question: '支持生成多长时间的舞蹈视频？',
                    answer: '生成的视频时长通常取决于您选择的舞蹈模板，一般在 5 到 30 秒之间，非常适合 TikTok、Instagram Reels 和 YouTube Shorts 等短视频平台传播。',
                },
            ]
        },
        modelIntro: {
            title: '释放你的创造力，开始使用 WeryAI 生成神奇的舞蹈视频',
            description: '尝试我们的 AI 舞蹈视频生成器',
            buttonText: '免费试用 WeryAI 舞蹈视频生成器',
            footerText: '无需信用卡'
        },
        
        // 页面SEO（可选）
        pageTitle: 'AI Dancing Video Generator - 免费AI跳舞视频生成器 | WeryAI',
        pageDescription: '使用WeryAI的AI Dancing生成器，上传照片即可生成精彩的跳舞视频。支持多种舞蹈模板和风格，让您的照片动起来！',
        pageKeywords: 'AI跳舞视频, AI舞蹈生成器, 照片生成视频, AI视频生成, WeryAI, 免费AI工具',
    },
    en: {
        // Video effects list display
        listTitle: 'AI Dancing Video Generator',
        listDesc: 'Make any photo dance to the rhythm',
        
        // Page title and description
        title: 'AI Dancing Video Generator',
        description: 'Upload a photo, select a dance template and type, and let AI generate an amazing dancing video for you',
        
        // Template preview section
        templatePreview: 'Template Preview',
        noTemplateSelected: 'Please select a dance type to view template',
        
        // Type section
        typesTitle: 'Select Dance Type',
        
        // Upload section
        uploadTitle: 'Upload Image',
        uploadHint: 'Upload clear portrait photos for better results',
        
        // Audio toggle
        generateAudioLabel: 'Generate Audio',
        
        // Button text
        generateButton: 'Generate',
        generating: 'Generating...',
        
        // Validation messages
        validation: {
            selectType: 'Please select a dance type',
            uploadImage: 'Please upload an image',
            loginRequired: 'Please login first',
        },
        
        // Feature hints
        featureComingSoon: 'AI Dancing feature coming soon, stay tuned!',
        processingHint: 'Generating your dancing video, please wait...',

        // Bottom Introduction Section
        introduce: {
            title: 'AI Dancing Video Generator',
            desc: 'Make any photo dance to the rhythm',
        },
        selectReason: {
            title: 'Why choose WeryAI Dancing Video Generator?',
            items: [
                {
                    title: 'One photo, instant "debut"',
                    desc: 'No expensive motion capture equipment or complex 3D animation skills needed. Just upload one full-body photo, and WeryAI\'s powerful skeletal binding and repainting technology will automatically identify joints and generate smooth, natural dance movements. Even without any dance background, you can become a top dancer in the video.',
                },
                {
                    title: 'Massive dance moves, follow the trend',
                    desc: 'Our library contains hundreds of popular dance templates and is constantly updated. From K-pop idol choreography, Street Dance (Hip-hop), Shuffle to various viral Meme dances, AI helps you dance whatever you want.',
                },
                {
                    title: 'Anything can dance, limitless creativity',
                    desc: 'Dancing is not just for humans! You can upload photos of anime characters, sculptures, toys, or even your pets. WeryAI can intelligently adapt to non-human body structures, creating hilarious or amazing creative dance videos, perfect for viral social content.',
                },
                {
                    title: 'Precise movements, realistic details',
                    desc: 'Worried about stiff movements or distorted faces? WeryAI uses advanced motion transfer algorithms to perfectly lock facial features and clothing details while maintaining large-scale body movements. No matter how intense the dance, the protagonist is still you, with no sense of incongruity.',
                },
            ]
        },
        howToUse: {
            title: 'How to use our AI Dancing Video Generator?',
            desc: 'Three steps to make your photo dance',
            steps: [
                {
                    title: 'Step 1 Upload Photo',
                    desc: 'Select a clear full-body photo (human, anime, or anthropomorphic animal), front standing pose works best.',
                },
                {
                    title: 'Step 2 Select Mode',
                    desc: 'Browse and select your favorite dance template (filter by style or popularity).',
                },
                {
                    title: 'Step 3 Generate Video',
                    desc: 'Click Generate, AI will automatically extract skeleton and perform motion transfer. In a few seconds, your exclusive dance video is born!',
                },
            ]
        },
        exploreOthers: {
            title: 'Explore other popular video effects on WeryAI',
            items: {
                kissing: 'AI Kissing Video',
                faceSwap: 'AI Video Face Swap',
                anime: 'AI Video to Anime',
            },
        },
        faq: {
            title: 'Frequently Asked Questions',
            items: [
                {
                    question: 'What is AI Dancing Video Generator?',
                    answer: 'It is a tool that uses artificial intelligence technology (mainly pose estimation and motion transfer) to convert static full-body photos into dynamic dance videos. Users can generate professional dance video content with just one image without filming.',
                },
                {
                    question: 'What kind of photos are needed for dance videos?',
                    answer: 'For best results, we recommend uploading a front standing photo with full body visible, well-lit, and without large obstructions. Although half-body photos can be processed, full-body photos allow leg and foot movements to be displayed more perfectly.',
                },
                {
                    question: 'Can I upload my own dance video as a reference?',
                    answer: 'Currently, we mainly provide rich preset templates. In future versions, we will open the "Video to Video" feature, allowing you to upload reference videos for the character in the photo to imitate specific movements.',
                },
                {
                    question: 'Can I generate AI dance videos for free?',
                    answer: 'Yes! We provide free credits for registered users, allowing everyone to experience and generate AI dance videos. For users who wish to remove watermarks or obtain 4K ultra-HD quality, we also offer flexible upgrade options.',
                },
                {
                    question: 'Is this tool safe? Will my photos be public?',
                    answer: 'Absolutely safe. We strictly protect your privacy. Your uploaded photos and generated videos are only used for your creation process and will be permanently deleted from the server within a specified time after processing, and will never be used for any commercial purpose or public display.',
                },
                {
                    question: 'How long can the generated dance video be?',
                    answer: 'The duration of the generated video usually depends on the dance template you choose, generally between 5 to 30 seconds, perfect for short video platforms like TikTok, Instagram Reels, and YouTube Shorts.',
                },
            ]
        },
        modelIntro: {
            title: 'Unleash your creativity, start using WeryAI to generate magical dance videos',
            description: 'Try our AI Dancing Video Generator',
            buttonText: 'Try WeryAI Dancing Video Generator for Free',
            footerText: 'No credit card required'
        },
        
        // Page SEO (optional)
        pageTitle: 'AI Dancing Video Generator - Free AI Dance Video Maker | WeryAI',
        pageDescription: 'Use WeryAI\'s AI Dancing Generator to create amazing dancing videos from photos. Support multiple dance templates and styles, bring your photos to life!',
        pageKeywords: 'AI dancing video, AI dance generator, photo to video, AI video generation, WeryAI, free AI tools',
    },
    ja: {
        // ビデオエフェクトリスト表示
        listTitle: 'AIダンス動画ジェネレーター',
        listDesc: 'どんな写真もリズムに合わせて踊らせる',
        
        title: 'AIダンス動画ジェネレーター',
        description: '写真をアップロードし、ダンステンプレートとタイプを選択して、AIが素晴らしいダンス動画を生成します',
        templatePreview: 'テンプレートプレビュー',
        noTemplateSelected: 'ダンスタイプを選択してテンプレートを表示してください',
        typesTitle: 'ダンスタイプを選択',
        uploadTitle: '画像をアップロード',
        uploadHint: 'より良い結果を得るために、鮮明な人物写真をアップロードしてください',
        generateAudioLabel: 'オーディオを生成',
        generateButton: '生成',
        generating: '生成中...',
        validation: {
            selectType: 'ダンスタイプを選択してください',
            uploadImage: '画像をアップロードしてください',
            loginRequired: '最初にログインしてください',
        },
        featureComingSoon: 'AI Dancingの機能は近日公開予定です。お楽しみに！',
        processingHint: 'ダンス動画を生成しています。しばらくお待ちください...',

        // ボトム紹介セクション
        introduce: {
            title: 'AIダンス動画ジェネレーター',
            desc: 'どんな写真もリズムに合わせて踊らせる',
        },
        selectReason: {
            title: 'なぜWeryAIダンス動画ジェネレーターを選ぶのか？',
            items: [
                {
                    title: '1枚の写真で、即「デビュー」',
                    desc: '高価なモーションキャプチャ機器や複雑な3Dアニメーションスキルは必要ありません。全身写真を1枚アップロードするだけで、WeryAIの強力な骨格バインディングと再描画技術が自動的に関節を識別し、スムーズで自然なダンスの動きを生成します。ダンスの経験がなくても、ビデオの中でトップダンサーになれます。',
                },
                {
                    title: '豊富なダンスムーブ、トレンドをキャッチ',
                    desc: '私たちのライブラリには何百もの人気のあるダンステンプレートが含まれており、常に更新されています。K-POPアイドルの振り付け、ストリートダンス（ヒップホップ）、シャッフルからバイラルなMemeダンスまで、AIがあなたの踊りたいものをサポートします。',
                },
                {
                    title: '何でも踊れる、無限の創造性',
                    desc: 'ダンスは人間だけのものではありません！アニメキャラクター、彫刻、おもちゃ、さらにはペットの写真もアップロードできます。WeryAIは人間以外の身体構造にもインテリジェントに適応し、陽気で素晴らしいクリエイティブなダンスビデオを作成し、バイラルなソーシャルコンテンツに最適です。',
                },
                {
                    title: '正確な動き、リアルなディテール',
                    desc: '動きがぎこちなかったり、顔が歪んだりするのが心配ですか？WeryAIは高度なモーション転送アルゴリズムを使用して、顔の特徴や衣服の細部を完全にロックしながら、大規模な身体の動きを維持します。どんなに激しいダンスでも、主役はあなたであり、違和感はありません。',
                },
            ]
        },
        howToUse: {
            title: 'AIダンス動画ジェネレーターの使い方は？',
            desc: 'あなたの写真を踊らせるための3つのステップ',
            steps: [
                {
                    title: 'ステップ1 写真をアップロード',
                    desc: '鮮明な全身写真（人物、アニメ、擬人化された動物）を選択してください。正面の立ちポーズが最適です。',
                },
                {
                    title: 'ステップ2 モードを選択',
                    desc: 'お気に入りのダンステンプレートを閲覧して選択します（スタイルや人気度でフィルタリング）。',
                },
                {
                    title: 'ステップ3 ビデオを生成',
                    desc: '生成をクリックすると、AIが自動的に骨格を抽出し、モーション転送を実行します。数秒で、あなただけのダンスビデオが誕生します！',
                },
            ]
        },
        exploreOthers: {
            title: 'WeryAIで他の人気のビデオエフェクトを探索',
            items: {
                kissing: 'AIキスビデオ',
                faceSwap: 'AIビデオ顔交換',
                anime: 'AIビデオアニメ化',
            },
        },
        faq: {
            title: 'よくある質問',
            items: [
                {
                    question: 'AIダンス動画ジェネレーターとは何ですか？',
                    answer: '人工知能技術（主に姿勢推定とモーション転送）を使用して、静止した全身写真を動的なダンスビデオに変換するツールです。ユーザーは撮影することなく、画像1枚だけでプロのダンスビデオコンテンツを生成できます。',
                },
                {
                    question: 'ダンスビデオにはどのような写真が必要ですか？',
                    answer: '最高の結果を得るために、全身が見え、十分に明るく、大きな遮蔽物のない正面の立ち写真をアップロードすることをお勧めします。半身写真も処理できますが、全身写真の方が脚や足の動きをより完璧に表現できます。',
                },
                {
                    question: '参考として自分のダンスビデオをアップロードできますか？',
                    answer: '現在、私たちは主に豊富なプリセットテンプレートを提供しています。将来のバージョンでは、「ビデオ・トゥ・ビデオ（Video to Video）」機能を公開し、写真のキャラクターが特定の動きを模倣するための参考ビデオをアップロードできるようにする予定です。',
                },
                {
                    question: 'AIダンスビデオを無料で生成できますか？',
                    answer: 'はい！登録ユーザーには無料クレジットを提供しており、すべてのユーザーがAIダンスビデオを体験・生成できます。透かしを削除したり、4K超高画質を取得したいユーザー向けに、柔軟なアップグレードオプションも提供しています。',
                },
                {
                    question: 'このツールは安全ですか？写真は公開されますか？',
                    answer: '絶対に安全です。私たちはお客様のプライバシーを厳重に保護します。アップロードされた写真や生成されたビデオは、作成プロセスにのみ使用され、処理完了後、指定された時間内にサーバーから完全に削除され、商業目的や公開展示に使用されることはありません。',
                },
                {
                    question: 'どのくらいの長さのダンスビデオを生成できますか？',
                    answer: '生成されるビデオの長さは通常、選択したダンステンプレートによって異なり、一般的に5秒から30秒の間で、TikTok、Instagram Reels、YouTube Shortsなどのショートビデオプラットフォームでの拡散に最適です。',
                },
            ]
        },
        modelIntro: {
            title: '創造力を解き放ち、WeryAIで魔法のようなダンスビデオを生成しましょう',
            description: 'AIダンス動画ジェネレーターを試す',
            buttonText: 'WeryAIダンス動画ジェネレーターを無料で試す',
            footerText: 'クレジットカード不要'
        },

        pageTitle: 'AI Dancing Video Generator - 無料AIダンスビデオメーカー | WeryAI',
        pageDescription: 'WeryAIのAI Dancingジェネレーターを使用して、写真から素晴らしいダンス動画を作成します。複数のダンステンプレートとスタイルをサポートし、写真に命を吹き込みます！',
        pageKeywords: 'AIダンスビデオ, AIダンスジェネレーター, 写真からビデオ, AIビデオ生成, WeryAI, 無料AIツール',
    },
    ko: {
        // 비디오 효과 목록 표시
        listTitle: 'AI 댄스 비디오 생성기',
        listDesc: '어떤 사진이든 리듬에 맞춰 춤추게 하세요',
        
        title: 'AI 댄스 비디오 생성기',
        description: '사진을 업로드하고 댄스 템플릿과 유형을 선택하면 AI가 놀라운 댄스 비디오를 생성합니다',
        templatePreview: '템플릿 미리보기',
        noTemplateSelected: '템플릿을 보려면 댄스 유형을 선택하세요',
        typesTitle: '댄스 유형 선택',
        uploadTitle: '이미지 업로드',
        uploadHint: '더 나은 결과를 위해 선명한 인물 사진을 업로드하세요',
        generateAudioLabel: '오디오 생성',
        generateButton: '생성',
        generating: '생성 중...',
        validation: {
            selectType: '댄스 유형을 선택하세요',
            uploadImage: '이미지를 업로드하세요',
            loginRequired: '먼저 로그인하세요',
        },
        featureComingSoon: 'AI Dancing 기능이 곧 출시됩니다. 기대해 주세요!',
        processingHint: '댄스 비디오를 생성 중입니다. 잠시만 기다려 주세요...',

        // 하단 소개 섹션
        introduce: {
            title: 'AI 댄스 비디오 생성기',
            desc: '어떤 사진이든 리듬에 맞춰 춤추게 하세요',
        },
        selectReason: {
            title: '왜 WeryAI 댄스 비디오 생성기를 선택해야 할까요?',
            items: [
                {
                    title: '사진 한 장으로 즉시 "데뷔"',
                    desc: '비싼 모션 캡처 장비나 복잡한 3D 애니메이션 기술이 필요 없습니다. 전신 사진 한 장만 업로드하면 WeryAI의 강력한 골격 바인딩 및 리페인팅 기술이 자동으로 관절을 식별하고 부드럽고 자연스러운 댄스 동작을 생성합니다. 댄스 경험이 없어도 비디오 속에서 최고의 댄서가 될 수 있습니다.',
                },
                {
                    title: '방대한 댄스 동작, 트렌드 팔로우',
                    desc: '저희 라이브러리에는 수백 가지의 인기 있는 댄스 템플릿이 포함되어 있으며 지속적으로 업데이트됩니다. K-pop 아이돌 안무, 스트릿 댄스(힙합), 셔플부터 다양한 바이럴 밈 댄스까지, AI가 당신이 추고 싶은 모든 춤을 도와드립니다.',
                },
                {
                    title: '무엇이든 춤출 수 있는 무한한 창의성',
                    desc: '춤은 인간만의 전유물이 아닙니다! 애니메이션 캐릭터, 조각상, 장난감, 심지어 반려동물의 사진도 업로드할 수 있습니다. WeryAI는 인간이 아닌 신체 구조에도 지능적으로 적응하여 유쾌하거나 놀라운 창의적인 댄스 비디오를 만들어내며, 바이럴 소셜 콘텐츠에 완벽합니다.',
                },
                {
                    title: '정확한 동작, 사실적인 디테일',
                    desc: '동작이 어색하거나 얼굴이 왜곡될까 걱정되시나요? WeryAI는 고급 모션 전송 알고리즘을 사용하여 얼굴 특징과 의상 디테일을 완벽하게 잠그면서 큰 신체 움직임을 유지합니다. 아무리 격렬한 춤이라도 주인공은 여전히 당신이며 위화감이 없습니다.',
                },
            ]
        },
        howToUse: {
            title: 'AI 댄스 비디오 생성기 사용 방법',
            desc: '사진을 춤추게 만드는 3단계',
            steps: [
                {
                    title: '1단계 사진 업로드',
                    desc: '선명한 전신 사진(인물, 애니메이션 또는 의인화된 동물)을 선택하세요. 정면 서 있는 자세가 가장 좋습니다.',
                },
                {
                    title: '2단계 모드 선택',
                    desc: '마음에 드는 댄스 템플릿을 찾아보고 선택하세요(스타일 또는 인기도로 필터링).',
                },
                {
                    title: '3단계 비디오 생성',
                    desc: '생성을 클릭하면 AI가 자동으로 골격을 추출하고 모션 전송을 수행합니다. 몇 초 만에 나만의 댄스 비디오가 탄생합니다!',
                },
            ]
        },
        exploreOthers: {
            title: 'WeryAI의 다른 인기 비디오 효과 살펴보기',
            items: {
                kissing: 'AI 키스 비디오',
                faceSwap: 'AI 비디오 얼굴 바꾸기',
                anime: 'AI 비디오 애니메이션 변환',
            },
        },
        faq: {
            title: '자주 묻는 질문',
            items: [
                {
                    question: 'AI 댄스 비디오 생성기란 무엇인가요?',
                    answer: '인공지능 기술(주로 자세 추정 및 모션 전송 기술)을 사용하여 정적인 전신 사진을 동적인 댄스 비디오로 변환하는 도구입니다. 사용자는 촬영 없이 이미지 한 장만으로 전문적인 댄스 비디오 콘텐츠를 생성할 수 있습니다.',
                },
                {
                    question: '댄스 비디오에는 어떤 사진이 필요한가요?',
                    answer: '최상의 결과를 얻으려면 전신이 보이고 충분히 밝으며 큰 가려짐이 없는 정면 서 있는 사진을 업로드하는 것이 좋습니다. 상반신 사진도 처리할 수 있지만 전신 사진이 다리와 발의 움직임을 더 완벽하게 표현할 수 있습니다.',
                },
                {
                    question: '참고용으로 내 댄스 비디오를 업로드할 수 있나요?',
                    answer: '현재는 주로 풍부한 사전 설정 템플릿을 제공합니다. 향후 버전에서는 "비디오 투 비디오(Video to Video)" 기능을 오픈하여 사진 속 캐릭터가 특정 동작을 모방할 수 있도록 참고 비디오를 업로드할 수 있게 할 예정입니다.',
                },
                {
                    question: 'AI 댄스 비디오를 무료로 생성할 수 있나요?',
                    answer: '네! 등록된 사용자에게 무료 크레딧을 제공하여 모든 사용자가 AI 댄스 비디오를 체험하고 생성할 수 있습니다. 워터마크를 제거하거나 4K 초고화질을 얻으려는 사용자를 위해 유연한 업그레이드 옵션도 제공합니다.',
                },
                {
                    question: '이 도구는 안전한가요? 제 사진이 공개되나요?',
                    answer: '절대적으로 안전합니다. 저희는 고객님의 개인정보를 엄격하게 보호합니다. 업로드된 사진과 생성된 비디오는 창작 과정에만 사용되며, 처리 완료 후 지정된 시간 내에 서버에서 영구적으로 삭제되며 상업적 목적이나 공개 전시에 사용되지 않습니다.',
                },
                {
                    question: '얼마나 긴 댄스 비디오를 생성할 수 있나요?',
                    answer: '생성되는 비디오의 길이는 일반적으로 선택한 댄스 템플릿에 따라 다르며, 대개 5초에서 30초 사이로 TikTok, Instagram Reels, YouTube Shorts 등의 숏폼 비디오 플랫폼에 공유하기에 적합합니다.',
                },
            ]
        },
        modelIntro: {
            title: '창의력을 발휘하고 WeryAI로 마법 같은 댄스 비디오를 만들어보세요',
            description: 'AI 댄스 비디오 생성기 체험하기',
            buttonText: 'WeryAI 댄스 비디오 생성기 무료 체험',
            footerText: '신용카드 필요 없음'
        },

        pageTitle: 'AI Dancing Video Generator - 무료 AI 댄스 비디오 메이커 | WeryAI',
        pageDescription: 'WeryAI의 AI Dancing 생성기를 사용하여 사진으로 놀라운 댄스 비디오를 만드세요. 다양한 댄스 템플릿과 스타일을 지원하여 사진에 생명을 불어넣으세요!',
        pageKeywords: 'AI 댄스 비디오, AI 댄스 생성기, 사진 비디오 변환, AI 비디오 생성, WeryAI, 무료 AI 도구',
    },
    tw: {

        // 影片特效列表展示
        listTitle: 'AI 舞蹈影片產生器',
        listDesc: '讓任意照片隨韻律舞動',
        
        // 頁面標題與描述
        title: 'AI 舞蹈影片產生器',
        description: '上傳照片，選擇舞蹈模板和類型，讓 AI 為您產生精彩的跳舞影片',
        
        // 模板預覽區域
        templatePreview: '模板預覽',
        noTemplateSelected: '請選擇一個舞蹈類型查看模板',
        
        // 類型區域
        typesTitle: '選擇舞蹈類型',
        
        // 上傳區域
        uploadTitle: '上傳圖片',
        uploadHint: '上傳清晰的人物照片，效果更佳',
        
        // 音訊開關
        generateAudioLabel: '產生音訊',
        
        // 按鈕文字
        generateButton: '產生',
        generating: '產生中...',
        
        // 驗證提示
        validation: {
            selectType: '請選擇舞蹈類型',
            uploadImage: '請上傳圖片',
            loginRequired: '請先登錄',
        },
        
        // 功能提示
        featureComingSoon: 'AI Dancing 功能即將上線，敬請期待！',
        processingHint: '正在產生您的跳舞影片，請稍候...',

        // 底部介紹區域
        introduce: {
            title: 'AI 舞蹈影片產生器',
            desc: '讓任意照片隨韻律舞動',
        },
        selectReason: {
            title: '為什麼選擇 WeryAI 舞蹈影片產生器？',
            items: [
                {
                    title: '一張照片，瞬間「出道」',
                    desc: '無需昂貴的動作捕捉設備，也不用學習複雜的 3D 動畫。只需一張全身照片，WeryAI 強大的骨骼綁定與重繪技術就能自動識別人物關節，產生流暢自然的舞蹈動作。哪怕是沒有任何舞蹈基礎的你，也能在影片中化身頂級舞者。',
                },
                {
                    title: '海量舞步，緊跟潮流',
                    desc: '我們的庫中收录了數百種熱門舞蹈模板，並持續更新。從 K-pop 偶像編舞、街舞 (Hip-hop)、鬼步舞 (Shuffle) 到各種網路爆款 Meme 舞蹈（如科目三等），你想跳什麼，AI 就幫你跳什麼。',
                },
                {
                    title: '萬物皆可舞，創意無邊界',
                    desc: '舞蹈不只是人類的專利！您可以上傳動漫角色、雕塑、玩具公仔甚至是你家寵物的照片。WeryAI 能智慧適配非人類的身體結構，製作出令人捧腹大笑或驚嘆不已的創意舞蹈影片，是製作病毒式社交內容的絕佳工具。',
                },
                {
                    title: '動作精準，細節逼真',
                    desc: '擔心動作僵硬或臉部崩壞？WeryAI 採用先進的動作遷移演算法，在保持大幅度肢体運動的同時，完美鎖定人物的面部特徵和服裝細節。無論舞蹈動作多麼激烈，主角依然是你，絕無違和感。',
                },
            ]
        },
        howToUse: {
            title: '如何使用我們的 AI 舞蹈影片產生器？',
            desc: '三步，讓你的照片跳起來',
            steps: [
                {
                    title: '步驟 1 上傳照片',
                    desc: '選擇一張清晰的全身照片（人物、動漫或擬人化動物均可），正面站立效果最佳。',
                },
                {
                    title: '第 2 步 選擇模式',
                    desc: '瀏覽並選擇您喜歡的舞蹈模板（支援按風格、熱門程度篩選）。',
                },
                {
                    title: '步驟 3 產生影片',
                    desc: '點擊產生，AI 將自動提取骨骼並進行動作遷移，幾秒鐘後，屬於你的專屬舞蹈影片就誕生了！',
                },
            ]
        },
        exploreOthers: {
            title: '探索 WeryAI 的其他熱門影片特效',
            items: {
                kissing: 'AI 親吻影片',
                faceSwap: 'AI 影片換臉',
                anime: 'AI 影片動漫轉換器',
            },
        },
        faq: {
            title: '常見問題解答',
            items: [
                {
                    question: '什麼是 AI 舞蹈影片產生器？',
                    answer: '它是一款利用人工智慧技術（主要是姿勢估計和動作遷移技術），將靜態的全身照片轉化為動態舞蹈影片的工具。用戶無需拍攝影片，僅憑一張圖就能產生擁有專業舞技的影片內容。',
                },
                {
                    question: '製作舞蹈影片需要什麼樣的照片？',
                    answer: '為了獲得最佳效果，我們建議上傳全身可見、光線充足、無大面積遮擋的正面站立照片。雖然半身照也能處理，但全身照能讓腿部和腳步動作展現得更加完美。',
                },
                {
                    question: '我可以上傳自己的舞蹈影片作為參考嗎？',
                    answer: '目前我們主要提供豐富的預設模板。在未來的版本中，我們將開放「影片轉影片 (Video to Video)」功能，允許您上傳參考影片，讓照片中的人物模仿特定的動作。',
                },
                {
                    question: '我可以免費產生 AI 舞蹈影片嗎？',
                    answer: '是的！我們為註冊用戶提供免費點數，讓每位用戶都能體驗並產生 AI 舞蹈影片。對於希望去除浮水印或獲取 4K 超清畫質的用戶，我們也提供靈活的升級選項。',
                },
                {
                    question: '這個工具安全嗎？我的照片會被公開嗎？',
                    answer: '絕對安全。我們嚴格保護您的隱私。您上傳的照片和產生的影片僅用於您的創作過程，處理完成後會在規定時間內從伺服器徹底刪除，絕不會用於任何商業用途或公開展示。',
                },
                {
                    question: '支持產生多長時間的舞蹈影片？',
                    answer: '產生的影片時長通常取決於您選擇的舞蹈模板，一般在 5 到 30 秒之間，非常適合 TikTok、Instagram Reels 和 YouTube Shorts 等短影片平台傳播。',
                },
            ]
        },
        modelIntro: {
            title: '釋放你的創造力，開始使用 WeryAI 產生神奇的舞蹈影片',
            description: '嘗試我們的 AI 舞蹈影片產生器',
            buttonText: '免費試用 WeryAI 舞蹈影片產生器',
            footerText: '無需信用卡'
        },
        
        // 頁面 SEO（可選）
        pageTitle: 'AI Dancing Video Generator - 免費 AI 跳舞影片產生器 | WeryAI',
        pageDescription: '使用 WeryAI 的 AI Dancing 產生器，上傳照片即可產生精彩的跳舞影片。支援多種舞蹈模板和風格，讓您的照片動起來！',
        pageKeywords: 'AI 跳舞影片, AI 舞蹈產生器, 照片產生影片, AI 影片產生, WeryAI, 免費 AI 工具',
    },
    pl: {
        listTitle: 'Generator wideo tańca AI',
        listDesc: 'Spraw, by dowolne zdjęcie tańczyło w rytm muzyki',
        title: 'Generator wideo tańca AI',
        description: 'Prześlij zdjęcie, wybierz szablon i typ tańca, a AI wygeneruje dla Ciebie niesamowite wideo z tańcem',
        templatePreview: 'Podgląd szablonu',
        noTemplateSelected: 'Wybierz typ tańca, aby wyświetlić szablon',
        typesTitle: 'Wybierz typ tańca',
        uploadTitle: 'Prześlij obraz',
        uploadHint: 'Prześlij wyraźne zdjęcia portretowe, aby uzyskać lepsze rezultaty',
        generateAudioLabel: 'Generuj dźwięk',
        generateButton: 'Generuj',
        generating: 'Generowanie...',
        validation: {
            selectType: 'Wybierz typ tańca',
            uploadImage: 'Prześlij obraz',
            loginRequired: 'Zaloguj się najpierw',
        },
        featureComingSoon: 'Funkcja AI Dancing pojawi się wkrótce, bądź na bieżąco!',
        processingHint: 'Generowanie Twojego wideo z tańcem, proszę czekać...',
        introduce: {
            title: 'Generator wideo tańca AI',
            desc: 'Spraw, by dowolne zdjęcie tańczyło w rytm muzyki',
        },
        selectReason: {
            title: 'Dlaczego warto wybrać Generator wideo tańca WeryAI?',
            items: [
                {
                    title: 'Jedno zdjęcie, natychmiastowy „debiut”',
                    desc: 'Nie potrzebujesz drogiego sprzętu do przechwytywania ruchu ani złożonych umiejętności animacji 3D. Po prostu prześlij jedno zdjęcie całej sylwetki, a potężna technologia wiązania szkieletowego i przerysowywania WeryAI automatycznie zidentyfikuje stawy i wygeneruje płynne, naturalne ruchy taneczne. Nawet bez doświadczenia tanecznego możesz stać się topowym tancerzem w wideo.',
                },
                {
                    title: 'Ogromna biblioteka ruchów, śledź trendy',
                    desc: 'Nasza biblioteka zawiera setki popularnych szablonów tanecznych i jest stale aktualizowana. Od choreografii idolów K-pop, przez Street Dance (Hip-hop), Shuffle, aż po różne wiralowe tańce z memów – AI pomoże Ci zatańczyć cokolwiek zechcesz.',
                },
                {
                    title: 'Wszystko może tańczyć, nieograniczona kreatywność',
                    desc: 'Taniec nie jest tylko dla ludzi! Możesz przesyłać zdjęcia postaci z anime, rzeźb, zabawek, a nawet swoich zwierząt. WeryAI potrafi inteligentnie dostosować się do nieludzkich struktur ciała, tworząc zabawne lub niesamowite kreatywne filmy z tańcem, idealne do wiralowych treści społecznościowych.',
                },
                {
                    title: 'Precyzyjne ruchy, realistyczne detale',
                    desc: 'Martwisz się o sztywne ruchy lub zniekształcone twarze? WeryAI wykorzystuje zaawansowane algorytmy transferu ruchu, aby idealnie zachować rysy twarzy i detale ubrań przy zachowaniu dużej skali ruchów ciała. Bez względu na to, jak intensywny jest taniec, bohaterem wciąż jesteś Ty, bez poczucia nienaturalności.',
                }
            ]
        },
        howToUse: {
            title: 'Jak korzystać z naszego Generatora wideo tańca AI?',
            desc: 'Trzy kroki, aby Twoje zdjęcie zatańczyło',
            steps: [
                {
                    title: 'Krok 1 Prześlij zdjęcie',
                    desc: 'Wybierz wyraźne zdjęcie całej sylwetki (człowiek, anime lub postać antropomorficzna), najlepiej w pozycji stojącej przodem.',
                },
                {
                    title: 'Krok 2 Wybierz tryb',
                    desc: 'Przeglądaj i wybierz swój ulubiony szablon tańca (filtruj według stylu lub popularności).',
                },
                {
                    title: 'Krok 3 Wygeneruj wideo',
                    desc: 'Kliknij Generuj, AI automatycznie wyodrębni szkielet i wykona transfer ruchu. W kilka sekund narodzi się Twoje ekskluzywne wideo z tańcem!',
                }
            ]
        },
        exploreOthers: {
            title: 'Odkryj inne popularne efekty wideo na WeryAI',
            items: {
                kissing: 'Wideo pocałunku AI',
                faceSwap: 'Zamiana twarzy w wideo AI',
                anime: 'Wideo do anime AI',
            },
        },
        faq: {
            title: 'Często zadawane pytania',
            items: [
                {
                    question: 'Czym jest Generator wideo tańca AI?',
                    answer: 'To narzędzie, które wykorzystuje technologię sztucznej inteligencji (głównie szacowanie pozy i transfer ruchu) do konwersji statycznych zdjęć całej sylwetki w dynamiczne filmy z tańcem. Użytkownicy mogą generować profesjonalne treści wideo z tańcem za pomocą tylko jednego obrazu, bez konieczności filmowania.',
                },
                {
                    question: 'Jakie zdjęcia są potrzebne do filmów z tańcem?',
                    answer: 'Aby uzyskać najlepsze rezultaty, zalecamy przesłanie zdjęcia stojącej sylwetki przodem, z widocznym całym ciałem, dobrze oświetlonego i bez dużych przeszkód. Chociaż zdjęcia od pasa w górę mogą być przetwarzane, zdjęcia całej sylwetki pozwalają na lepsze wyświetlanie ruchów nóg i stóp.',
                },
                {
                    question: 'Czy mogę przesłać własne wideo z tańcem jako odniesienie?',
                    answer: 'Obecnie oferujemy głównie bogatą bibliotekę gotowych szablonów. W przyszłych wersjach udostępnimy funkcję „Video to Video”, która pozwoli na przesyłanie filmów referencyjnych, aby postać na zdjęciu naśladowała określone ruchy.',
                },
                {
                    question: 'Czy mogę generować wideo z tańcem AI za darmo?',
                    answer: 'Tak! Oferujemy darmowe punkty dla zarejestrowanych użytkowników, aby każdy mógł wypróbować i generować filmy z tańcem AI. Dla osób, które chcą usunąć znak wodny lub uzyskać jakość 4K, oferujemy elastyczne opcje ulepszenia konta.',
                },
                {
                    question: 'Czy to narzędzie jest bezpieczne? Czy moje zdjęcia będą publiczne?',
                    answer: 'Absolutnie bezpieczne. Ściśle chronimy Twoją prywatność. Twoje przesłane zdjęcia i wygenerowane filmy są używane tylko w procesie tworzenia, a po zakończeniu przetwarzania zostaną całkowicie usunięte z serwerów w określonym czasie. Nigdy nie zostaną użyte do celów komercyjnych ani publicznie wyświetlone.',
                },
                {
                    question: 'Jak długie filmy z tańcem można generować?',
                    answer: 'Długość generowanego wideo zależy zazwyczaj od wybranego szablonu, zwykle wynosi od 5 do 30 sekund, co jest idealne do udostępniania na platformach takich jak TikTok, Instagram Reels i YouTube Shorts.',
                }
            ]
        },
        modelIntro: {
            title: 'Uwolnij swoją kreatywność, zacznij używać WeryAI do generowania magicznych filmów z tańcem',
            description: 'Wypróbuj nasz Generator wideo tańca AI',
            buttonText: 'Wypróbuj Generator wideo tańca WeryAI za darmo',
            footerText: 'Nie wymaga karty kredytowej'
        },
        pageTitle: 'Generator tańca AI - Darmowy twórca wideo tańca AI | WeryAI',
        pageDescription: 'Użyj Generatora tańca AI WeryAI, aby tworzyć niesamowite filmy z tańcem ze zdjęć. Wspiera wiele szablonów i stylów, ożyw swoje zdjęcia!',
        pageKeywords: 'Wideo tańca AI, generator tańca AI, zdjęcie do wideo, generowanie wideo AI, WeryAI, darmowe narzędzia AI',
    },
    es: {
        // Visualización de la lista de efectos de vídeo
        listTitle: 'Generador de Vídeo de Baile AI',
        listDesc: 'Haz que cualquier foto baile al ritmo',

        title: 'Generador de Vídeo de Baile AI',
        description: 'Sube una foto, selecciona una plantilla y tipo de baile, y deja que la IA genere un increíble vídeo de baile para ti',
        templatePreview: 'Vista previa de plantilla',
        noTemplateSelected: 'Selecciona un tipo de baile para ver la plantilla',
        typesTitle: 'Seleccionar tipo de baile',
        uploadTitle: 'Subir imagen',
        uploadHint: 'Sube fotos de retrato claras para mejores resultados',
        generateAudioLabel: 'Generar audio',
        generateButton: 'Generar',
        generating: 'Generando...',
        validation: {
            selectType: 'Por favor selecciona un tipo de baile',
            uploadImage: 'Por favor sube una imagen',
            loginRequired: 'Por favor inicia sesión primero',
        },
        featureComingSoon: '¡La función AI Dancing llegará pronto, mantente atento!',
        processingHint: 'Generando tu vídeo de baile, por favor espera...',

        // Sección de introducción inferior
        introduce: {
            title: 'Generador de Vídeo de Baile AI',
            desc: 'Haz que cualquier foto baile al ritmo',
        },
        selectReason: {
            title: '¿Por qué elegir el Generador de Vídeo de Baile WeryAI?',
            items: [
                {
                    title: 'Una foto, "debut" instantáneo',
                    desc: 'No necesitas equipos costosos de captura de movimiento ni habilidades complejas de animación 3D. Solo sube una foto de cuerpo completo, y la potente tecnología de unión esquelética y repintado de WeryAI identificará automáticamente las articulaciones y generará movimientos de baile suaves y naturales. Incluso sin experiencia en baile, puedes convertirte en un bailarín top en el vídeo.',
                },
                {
                    title: 'Movimientos de baile masivos, sigue la tendencia',
                    desc: 'Nuestra biblioteca contiene cientos de plantillas de baile populares y se actualiza constantemente. Desde coreografías de ídolos de K-pop, Street Dance (Hip-hop), Shuffle hasta varios bailes virales de memes, la IA te ayuda a bailar lo que quieras.',
                },
                {
                    title: 'Cualquier cosa puede bailar, creatividad ilimitada',
                    desc: '¡Bailar no es solo para humanos! Puedes subir fotos de personajes de anime, esculturas, juguetes o incluso tus mascotas. WeryAI puede adaptarse inteligentemente a estructuras corporales no humanas, creando vídeos de baile divertidos o asombrosos, perfectos para contenido social viral.',
                },
                {
                    title: 'Movimientos precisos, detalles realistas',
                    desc: '¿Te preocupan los movimientos rígidos o las caras distorsionadas? WeryAI utiliza algoritmos avanzados de transferencia de movimiento para bloquear perfectamente los rasgos faciales y los detalles de la ropa mientras mantiene movimientos corporales a gran escala. No importa cuán intenso sea el baile, el protagonista sigues siendo tú, sin sensación de incongruencia.',
                },
            ]
        },
        howToUse: {
            title: '¿Cómo usar nuestro Generador de Vídeo de Baile AI?',
            desc: 'Tres pasos para hacer bailar tu foto',
            steps: [
                {
                    title: 'Paso 1 Subir foto',
                    desc: 'Selecciona una foto de cuerpo completo clara (humano, anime o animal antropomórfico), la pose de pie frontal funciona mejor.',
                },
                {
                    title: 'Paso 2 Seleccionar modo',
                    desc: 'Navega y selecciona tu plantilla de baile favorita (filtra por estilo o popularidad).',
                },
                {
                    title: 'Paso 3 Generar vídeo',
                    desc: 'Haz clic en Generar, la IA extraerá automáticamente el esqueleto y realizará la transferencia de movimiento. ¡En unos segundos, nace tu vídeo de baile exclusivo!',
                },
            ]
        },
        exploreOthers: {
            title: 'Explora otros efectos de vídeo populares en WeryAI',
            items: {
                kissing: 'Vídeo de Beso AI',
                faceSwap: 'Intercambio de Cara en Vídeo AI',
                anime: 'Vídeo a Anime AI',
            },
        },
        faq: {
            title: 'Preguntas frecuentes',
            items: [
                {
                    question: '¿Qué es el Generador de Vídeo de Baile AI?',
                    answer: 'Es una herramienta que utiliza tecnología de inteligencia artificial (principalmente estimación de pose y transferencia de movimiento) para convertir fotos estáticas de cuerpo completo en vídeos de baile dinámicos. Los usuarios pueden generar contenido de vídeo de baile profesional con solo una imagen sin filmar.',
                },
                {
                    question: '¿Qué tipo de fotos se necesitan para los vídeos de baile?',
                    answer: 'Para obtener los mejores resultados, recomendamos subir una foto de pie frontal con el cuerpo completo visible, bien iluminada y sin grandes obstrucciones. Aunque las fotos de medio cuerpo se pueden procesar, las fotos de cuerpo completo permiten que los movimientos de piernas y pies se muestren más perfectamente.',
                },
                {
                    question: '¿Puedo subir mi propio vídeo de baile como referencia?',
                    answer: 'Actualmente, proporcionamos principalmente ricas plantillas preestablecidas. En futuras versiones, abriremos la función "Vídeo a Vídeo (Video to Video)", permitiéndote subir vídeos de referencia para que el personaje de la foto imite movimientos específicos.',
                },
                {
                    question: '¿Puedo generar vídeos de baile AI gratis?',
                    answer: '¡Sí! Proporcionamos créditos gratuitos para usuarios registrados, permitiendo que todos experimenten y generen vídeos de baile AI. Para los usuarios que deseen eliminar marcas de agua u obtener calidad ultra HD 4K, también ofrecemos opciones de actualización flexibles.',
                },
                {
                    question: '¿Es segura esta herramienta? ¿Se harán públicas mis fotos?',
                    answer: 'Absolutamente seguro. Protegemos estrictamente tu privacidad. Tus fotos subidas y vídeos generados solo se utilizan para tu proceso de creación y se eliminarán permanentemente del servidor dentro de un tiempo específico después del procesamiento, y nunca se utilizarán para ningún propósito comercial o exhibición pública.',
                },
                {
                    question: '¿Qué duración puede tener el vídeo de baile generado?',
                    answer: 'La duración del vídeo generado generalmente depende de la plantilla de baile que elijas, generalmente entre 5 y 30 segundos, perfecto para plataformas de vídeos cortos como TikTok, Instagram Reels y YouTube Shorts.',
                },
            ]
        },
        modelIntro: {
            title: 'Da rienda suelta a tu creatividad, comienza a usar WeryAI para generar vídeos de baile mágicos',
            description: 'Prueba nuestro Generador de Vídeo de Baile AI',
            buttonText: 'Prueba el Generador de Vídeo de Baile WeryAI gratis',
            footerText: 'No se requiere tarjeta de crédito'
        },

        pageTitle: 'Generador de Vídeo de Baile AI - Creador de Vídeos de Baile AI Gratis | WeryAI',
        pageDescription: 'Usa el Generador de Baile AI de WeryAI para crear increíbles vídeos de baile a partir de fotos. ¡Soporta múltiples plantillas y estilos de baile, dale vida a tus fotos!',
        pageKeywords: 'vídeo de baile AI, generador de baile AI, foto a vídeo, generación de vídeo AI, WeryAI, herramientas de IA gratis',
    },
    fr: {
        // Affichage de la liste des effets vidéo
        listTitle: 'Générateur de Vidéo de Danse IA',
        listDesc: 'Faites danser n\'importe quelle photo au rythme',

        title: 'Générateur de Vidéo de Danse IA',
        description: 'Téléchargez une photo, sélectionnez un modèle et un type de danse, et laissez l\'IA générer une incroyable vidéo de danse pour vous',
        templatePreview: 'Aperçu du modèle',
        noTemplateSelected: 'Veuillez sélectionner un type de danse pour voir le modèle',
        typesTitle: 'Sélectionner le type de danse',
        uploadTitle: 'Télécharger une image',
        uploadHint: 'Téléchargez des photos de portrait claires pour de meilleurs résultats',
        generateAudioLabel: 'Générer de l\'audio',
        generateButton: 'Générer',
        generating: 'Génération...',
        validation: {
            selectType: 'Veuillez sélectionner un type de danse',
            uploadImage: 'Veuillez télécharger une image',
            loginRequired: 'Veuillez d\'abord vous connecter',
        },
        featureComingSoon: 'La fonctionnalité AI Dancing arrive bientôt, restez à l\'écoute !',
        processingHint: 'Génération de votre vidéo de danse, veuillez patienter...',

        // Section d'introduction inférieure
        introduce: {
            title: 'Générateur de Vidéo de Danse IA',
            desc: 'Faites danser n\'importe quelle photo au rythme',
        },
        selectReason: {
            title: 'Pourquoi choisir le Générateur de Vidéo de Danse WeryAI ?',
            items: [
                {
                    title: 'Une photo, "début" instantané',
                    desc: 'Pas besoin d\'équipement de capture de mouvement coûteux ou de compétences complexes en animation 3D. Téléchargez simplement une photo en pied, et la puissante technologie de liaison squelettique et de repeinture de WeryAI identifiera automatiquement les articulations et générera des mouvements de danse fluides et naturels. Même sans aucune expérience de la danse, vous pouvez devenir un danseur de haut niveau dans la vidéo.',
                },
                {
                    title: 'Mouvements de danse massifs, suivez la tendance',
                    desc: 'Notre bibliothèque contient des centaines de modèles de danse populaires et est constamment mise à jour. Des chorégraphies d\'idoles de K-pop, Street Dance (Hip-hop), Shuffle aux diverses danses virales de mèmes, l\'IA vous aide à danser ce que vous voulez.',
                },
                {
                    title: 'Tout peut danser, créativité illimitée',
                    desc: 'La danse n\'est pas réservée aux humains ! Vous pouvez télécharger des photos de personnages d\'anime, de sculptures, de jouets ou même de vos animaux de compagnie. WeryAI peut s\'adapter intelligemment aux structures corporelles non humaines, créant des vidéos de danse hilarantes ou étonnantes, parfaites pour du contenu social viral.',
                },
                {
                    title: 'Mouvements précis, détails réalistes',
                    desc: 'Inquiet des mouvements raides ou des visages déformés ? WeryAI utilise des algorithmes avancés de transfert de mouvement pour verrouiller parfaitement les traits du visage et les détails des vêtements tout en maintenant des mouvements corporels à grande échelle. Quelle que soit l\'intensité de la danse, le protagoniste reste vous, sans sentiment d\'incongruité.',
                },
            ]
        },
        howToUse: {
            title: 'Comment utiliser notre Générateur de Vidéo de Danse IA ?',
            desc: 'Trois étapes pour faire danser votre photo',
            steps: [
                {
                    title: 'Étape 1 Télécharger la photo',
                    desc: 'Sélectionnez une photo en pied claire (humain, anime ou animal anthropomorphe), la pose debout de face fonctionne le mieux.',
                },
                {
                    title: 'Étape 2 Sélectionner le mode',
                    desc: 'Parcourez et sélectionnez votre modèle de danse préféré (filtrez par style ou popularité).',
                },
                {
                    title: 'Étape 3 Générer la vidéo',
                    desc: 'Cliquez sur Générer, l\'IA extraira automatiquement le squelette et effectuera le transfert de mouvement. En quelques secondes, votre vidéo de danse exclusive est née !',
                },
            ]
        },
        exploreOthers: {
            title: 'Explorez d\'autres effets vidéo populaires sur WeryAI',
            items: {
                kissing: 'Vidéo de Baiser IA',
                faceSwap: 'Échange de Visage Vidéo IA',
                anime: 'Vidéo vers Anime IA',
            },
        },
        faq: {
            title: 'Questions fréquemment posées',
            items: [
                {
                    question: 'Qu\'est-ce que le Générateur de Vidéo de Danse IA ?',
                    answer: 'C\'est un outil qui utilise la technologie de l\'intelligence artificielle (principalement l\'estimation de pose et le transfert de mouvement) pour convertir des photos statiques en pied en vidéos de danse dynamiques. Les utilisateurs peuvent générer du contenu vidéo de danse professionnel avec une seule image sans filmer.',
                },
                {
                    question: 'Quel type de photos est nécessaire pour les vidéos de danse ?',
                    answer: 'Pour de meilleurs résultats, nous recommandons de télécharger une photo debout de face avec tout le corps visible, bien éclairée et sans grandes obstructions. Bien que les photos à mi-corps puissent être traitées, les photos en pied permettent d\'afficher plus parfaitement les mouvements des jambes et des pieds.',
                },
                {
                    question: 'Puis-je télécharger ma propre vidéo de danse comme référence ?',
                    answer: 'Actuellement, nous fournissons principalement de riches modèles prédéfinis. Dans les futures versions, nous ouvrirons la fonctionnalité "Vidéo vers Vidéo (Video to Video)", vous permettant de télécharger des vidéos de référence pour que le personnage de la photo imite des mouvements spécifiques.',
                },
                {
                    question: 'Puis-je générer des vidéos de danse IA gratuitement ?',
                    answer: 'Oui ! Nous fournissons des crédits gratuits aux utilisateurs enregistrés, permettant à chacun de tester et de générer des vidéos de danse IA. Pour les utilisateurs qui souhaitent supprimer les filigranes ou obtenir une qualité ultra HD 4K, nous proposons également des options de mise à niveau flexibles.',
                },
                {
                    question: 'Cet outil est-il sûr ? Mes photos seront-elles publiques ?',
                    answer: 'Absolument sûr. Nous protégeons strictement votre vie privée. Vos photos téléchargées et vidéos générées ne sont utilisées que pour votre processus de création et seront définitivement supprimées du serveur dans un délai spécifié après le traitement, et ne seront jamais utilisées à des fins commerciales ou d\'exposition publique.',
                },
                {
                    question: 'Quelle durée de vidéo de danse peut-on générer ?',
                    answer: 'La durée de la vidéo générée dépend généralement du modèle de danse que vous choisissez, généralement entre 5 et 30 secondes, parfait pour les plateformes de vidéos courtes comme TikTok, Instagram Reels et YouTube Shorts.',
                },
            ]
        },
        modelIntro: {
            title: 'Libérez votre créativité, commencez à utiliser WeryAI pour générer des vidéos de danse magiques',
            description: 'Essayez notre Générateur de Vidéo de Danse IA',
            buttonText: 'Essayez gratuitement le Générateur de Vidéo de Danse WeryAI',
            footerText: 'Pas de carte de crédit requise'
        },

        pageTitle: 'Générateur de Vidéo de Danse IA - Créateur de Vidéo de Danse IA Gratuit | WeryAI',
        pageDescription: 'Utilisez le Générateur de Danse IA de WeryAI pour créer d\'incroyables vidéos de danse à partir de photos. Prend en charge plusieurs modèles et styles de danse, donnez vie à vos photos !',
        pageKeywords: 'vidéo de danse IA, générateur de danse IA, photo en vidéo, génération de vidéo IA, WeryAI, outils IA gratuits',
    },
    de: {
        // Videoeffekt-Listenanzeige
        listTitle: 'AI Tanzvideo-Generator',
        listDesc: 'Lassen Sie jedes Foto im Rhythmus tanzen',

        title: 'AI Tanzvideo-Generator',
        description: 'Laden Sie ein Foto hoch, wählen Sie eine Tanzvorlage und einen Typ aus und lassen Sie die KI ein erstaunliches Tanzvideo für Sie erstellen',
        templatePreview: 'Vorlagenvorschau',
        noTemplateSelected: 'Bitte wählen Sie einen Tanztyp aus, um die Vorlage anzuzeigen',
        typesTitle: 'Tanztyp auswählen',
        uploadTitle: 'Bild hochladen',
        uploadHint: 'Laden Sie klare Porträtfotos für bessere Ergebnisse hoch',
        generateAudioLabel: 'Audio generieren',
        generateButton: 'Generieren',
        generating: 'Generieren...',
        validation: {
            selectType: 'Bitte wählen Sie einen Tanztyp aus',
            uploadImage: 'Bitte laden Sie ein Bild hoch',
            loginRequired: 'Bitte melden Sie sich zuerst an',
        },
        featureComingSoon: 'Die AI Dancing-Funktion kommt bald, bleiben Sie dran!',
        processingHint: 'Erstelle Ihr Tanzvideo, bitte warten...',

        // Unterer Einführungsbereich
        introduce: {
            title: 'AI Tanzvideo-Generator',
            desc: 'Lassen Sie jedes Foto im Rhythmus tanzen',
        },
        selectReason: {
            title: 'Warum den WeryAI Tanzvideo-Generator wählen?',
            items: [
                {
                    title: 'Ein Foto, sofortiges "Debüt"',
                    desc: 'Keine teure Motion-Capture-Ausrüstung oder komplexe 3D-Animationskenntnisse erforderlich. Laden Sie einfach ein Ganzkörperfoto hoch, und die leistungsstarke Skelettbindungs- und Repainting-Technologie von WeryAI identifiziert automatisch Gelenke und generiert flüssige, natürliche Tanzbewegungen. Auch ohne Tanzerfahrung können Sie im Video zum Top-Tänzer werden.',
                },
                {
                    title: 'Massive Tanzbewegungen, folgen Sie dem Trend',
                    desc: 'Unsere Bibliothek enthält Hunderte von beliebten Tanzvorlagen und wird ständig aktualisiert. Von K-Pop-Idol-Choreografie, Street Dance (Hip-Hop), Shuffle bis hin zu verschiedenen viralen Meme-Tänzen hilft Ihnen die KI, alles zu tanzen, was Sie wollen.',
                },
                {
                    title: 'Alles kann tanzen, grenzenlose Kreativität',
                    desc: 'Tanzen ist nicht nur für Menschen! Sie können Fotos von Anime-Charakteren, Skulpturen, Spielzeug oder sogar Ihren Haustieren hochladen. WeryAI kann sich intelligent an nicht-menschliche Körperstrukturen anpassen und urkomische oder erstaunliche kreative Tanzvideos erstellen, perfekt für virale soziale Inhalte.',
                },
                {
                    title: 'Präzise Bewegungen, realistische Details',
                    desc: 'Besorgt über steife Bewegungen oder verzerrte Gesichter? WeryAI verwendet fortschrittliche Bewegungsübertragungsalgorithmen, um Gesichtszüge und Kleidungsdetails perfekt zu fixieren, während groß angelegte Körperbewegungen erhalten bleiben. Egal wie intensiv der Tanz ist, der Protagonist sind immer noch Sie, ohne Gefühl der Unstimmigkeit.',
                },
            ]
        },
        howToUse: {
            title: 'Wie benutzt man unseren AI Tanzvideo-Generator?',
            desc: 'Drei Schritte, um Ihr Foto tanzen zu lassen',
            steps: [
                {
                    title: 'Schritt 1 Foto hochladen',
                    desc: 'Wählen Sie ein klares Ganzkörperfoto (Mensch, Anime oder anthropomorphes Tier), eine frontale stehende Pose funktioniert am besten.',
                },
                {
                    title: 'Schritt 2 Modus auswählen',
                    desc: 'Durchsuchen und wählen Sie Ihre bevorzugte Tanzvorlage aus (filtern Sie nach Stil oder Beliebtheit).',
                },
                {
                    title: 'Schritt 3 Video generieren',
                    desc: 'Klicken Sie auf Generieren, die KI extrahiert automatisch das Skelett und führt die Bewegungsübertragung durch. In wenigen Sekunden ist Ihr exklusives Tanzvideo geboren!',
                },
            ]
        },
        exploreOthers: {
            title: 'Entdecken Sie andere beliebte Videoeffekte auf WeryAI',
            items: {
                kissing: 'AI Kuss-Video',
                faceSwap: 'AI Video-Gesichtstausch',
                anime: 'AI Video zu Anime',
            },
        },
        faq: {
            title: 'Häufig gestellte Fragen',
            items: [
                {
                    question: 'Was ist der AI Tanzvideo-Generator?',
                    answer: 'Es ist ein Werkzeug, das künstliche Intelligenztechnologie (hauptsächlich Posenschätzung und Bewegungsübertragung) verwendet, um statische Ganzkörperfotos in dynamische Tanzvideos umzuwandeln. Benutzer können professionelle Tanzvideoinhalte mit nur einem Bild erstellen, ohne zu filmen.',
                },
                {
                    question: 'Welche Art von Fotos werden für Tanzvideos benötigt?',
                    answer: 'Für beste Ergebnisse empfehlen wir, ein frontales stehendes Foto hochzuladen, auf dem der ganze Körper sichtbar ist, gut beleuchtet und ohne große Hindernisse. Obwohl Halbkörperfotos verarbeitet werden können, ermöglichen Ganzkörperfotos eine perfektere Darstellung von Bein- und Fußbewegungen.',
                },
                {
                    question: 'Kann ich mein eigenes Tanzvideo als Referenz hochladen?',
                    answer: 'Derzeit bieten wir hauptsächlich umfangreiche voreingestellte Vorlagen an. In zukünftigen Versionen werden wir die Funktion "Video zu Video" (Video to Video) öffnen, mit der Sie Referenzvideos hochladen können, damit der Charakter auf dem Foto bestimmte Bewegungen nachahmen kann.',
                },
                {
                    question: 'Kann ich AI Tanzvideos kostenlos generieren?',
                    answer: 'Ja! Wir bieten registrierten Benutzern kostenlose Credits, damit jeder AI Tanzvideos erleben und generieren kann. Für Benutzer, die Wasserzeichen entfernen oder 4K Ultra-HD-Qualität erhalten möchten, bieten wir auch flexible Upgrade-Optionen an.',
                },
                {
                    question: 'Ist dieses Werkzeug sicher? Werden meine Fotos öffentlich sein?',
                    answer: 'Absolut sicher. Wir schützen Ihre Privatsphäre streng. Ihre hochgeladenen Fotos und generierten Videos werden nur für Ihren Erstellungsprozess verwendet und innerhalb einer bestimmten Zeit nach der Verarbeitung dauerhaft vom Server gelöscht und niemals für kommerzielle Zwecke oder öffentliche Ausstellungen verwendet.',
                },
                {
                    question: 'Wie lang kann das generierte Tanzvideo sein?',
                    answer: 'Die Dauer des generierten Videos hängt normalerweise von der gewählten Tanzvorlage ab, in der Regel zwischen 5 und 30 Sekunden, perfekt für Kurzvideoplattformen wie TikTok, Instagram Reels und YouTube Shorts.',
                },
            ]
        },
        modelIntro: {
            title: 'Entfesseln Sie Ihre Kreativität, beginnen Sie mit WeryAI, magische Tanzvideos zu erstellen',
            description: 'Probieren Sie unseren AI Tanzvideo-Generator aus',
            buttonText: 'Testen Sie den WeryAI Tanzvideo-Generator kostenlos',
            footerText: 'Keine Kreditkarte erforderlich'
        },

        pageTitle: 'AI Tanzvideo-Generator - Kostenloser AI Tanzvideo-Maker | WeryAI',
        pageDescription: 'Verwenden Sie den AI Dancing Generator von WeryAI, um erstaunliche Tanzvideos aus Fotos zu erstellen. Unterstützt mehrere Tanzvorlagen und Stile, erwecken Sie Ihre Fotos zum Leben!',
        pageKeywords: 'AI Tanzvideo, AI Tanzgenerator, Foto zu Video, AI Videogenerierung, WeryAI, kostenlose AI Tools',
    },
    ru: {
        // Отображение списка видеоэффектов
        listTitle: 'Генератор танцевальных видео с ИИ',
        listDesc: 'Заставьте любое фото танцевать в ритме',

        title: 'Генератор танцевальных видео с ИИ',
        description: 'Загрузите фото, выберите танцевальный шаблон и тип, и позвольте ИИ создать для вас удивительное танцевальное видео',
        templatePreview: 'Предпросмотр шаблона',
        noTemplateSelected: 'Пожалуйста, выберите тип танца для просмотра шаблона',
        typesTitle: 'Выберите тип танца',
        uploadTitle: 'Загрузить изображение',
        uploadHint: 'Загружайте четкие портретные фото для лучших результатов',
        generateAudioLabel: 'Генерировать аудио',
        generateButton: 'Создать',
        generating: 'Создание...',
        validation: {
            selectType: 'Пожалуйста, выберите тип танца',
            uploadImage: 'Пожалуйста, загрузите изображение',
            loginRequired: 'Пожалуйста, сначала войдите',
        },
        featureComingSoon: 'Функция AI Dancing скоро появится, следите за обновлениями!',
        processingHint: 'Создаем ваше танцевальное видео, пожалуйста, подождите...',

        // Нижняя секция введения
        introduce: {
            title: 'Генератор танцевальных видео с ИИ',
            desc: 'Заставьте любое фото танцевать в ритме',
        },
        selectReason: {
            title: 'Почему стоит выбрать генератор танцевальных видео WeryAI?',
            items: [
                {
                    title: 'Одно фото, мгновенный "дебют"',
                    desc: 'Не нужно дорогостоящее оборудование для захвата движения или сложные навыки 3D-анимации. Просто загрузите одно фото в полный рост, и мощная технология привязки скелета и перерисовки WeryAI автоматически определит суставы и создаст плавные, естественные танцевальные движения. Даже без танцевального опыта вы можете стать топ-танцором в видео.',
                },
                {
                    title: 'Множество танцевальных движений, следуйте тренду',
                    desc: 'Наша библиотека содержит сотни популярных танцевальных шаблонов и постоянно обновляется. От хореографии K-pop айдолов, уличных танцев (хип-хоп), шаффла до различных вирусных мемов-танцев, ИИ поможет вам станцевать все, что вы хотите.',
                },
                {
                    title: 'Танцевать может все, безграничное творчество',
                    desc: 'Танцы не только для людей! Вы можете загружать фото персонажей аниме, скульптур, игрушек или даже ваших питомцев. WeryAI может интеллектуально адаптироваться к нечеловеческим структурам тела, создавая уморительные или удивительные креативные танцевальные видео, идеально подходящие для вирусного контента в соцсетях.',
                },
                {
                    title: 'Точные движения, реалистичные детали',
                    desc: 'Беспокоитесь о скованных движениях или искаженных лицах? WeryAI использует передовые алгоритмы переноса движения, чтобы идеально фиксировать черты лица и детали одежды, сохраняя при этом крупномасштабные движения тела. Каким бы интенсивным ни был танец, главный герой по-прежнему вы, без ощущения несоответствия.',
                },
            ]
        },
        howToUse: {
            title: 'Как использовать наш генератор танцевальных видео с ИИ?',
            desc: 'Три шага, чтобы заставить ваше фото танцевать',
            steps: [
                {
                    title: 'Шаг 1 Загрузите фото',
                    desc: 'Выберите четкое фото в полный рост (человек, аниме или антропоморфное животное), лучше всего подходит поза стоя лицом вперед.',
                },
                {
                    title: 'Шаг 2 Выберите режим',
                    desc: 'Просмотрите и выберите понравившийся танцевальный шаблон (фильтруйте по стилю или популярности).',
                },
                {
                    title: 'Шаг 3 Создайте видео',
                    desc: 'Нажмите "Создать", ИИ автоматически извлечет скелет и выполнит перенос движения. Через несколько секунд ваше эксклюзивное танцевальное видео готово!',
                },
            ]
        },
        exploreOthers: {
            title: 'Изучите другие популярные видеоэффекты на WeryAI',
            items: {
                kissing: 'Видео с поцелуем ИИ',
                faceSwap: 'Замена лица в видео с ИИ',
                anime: 'Видео в аниме с ИИ',
            },
        },
        faq: {
            title: 'Часто задаваемые вопросы',
            items: [
                {
                    question: 'Что такое генератор танцевальных видео с ИИ?',
                    answer: 'Это инструмент, который использует технологию искусственного интеллекта (в основном оценку позы и перенос движения) для преобразования статических фото в полный рост в динамичные танцевальные видео. Пользователи могут создавать профессиональный танцевальный видеоконтент всего из одного изображения без съемки.',
                },
                {
                    question: 'Какие фото нужны для танцевальных видео?',
                    answer: 'Для лучших результатов мы рекомендуем загружать фото стоя лицом вперед с полностью видимым телом, хорошо освещенное и без крупных препятствий. Хотя фото по пояс могут быть обработаны, фото в полный рост позволяют более совершенно отображать движения ног и ступней.',
                },
                {
                    question: 'Могу ли я загрузить свое собственное танцевальное видео в качестве референса?',
                    answer: 'В настоящее время мы в основном предоставляем богатые предустановленные шаблоны. В будущих версиях мы откроем функцию "Видео в Видео (Video to Video)", позволяющую загружать референсные видео, чтобы персонаж на фото имитировал определенные движения.',
                },
                {
                    question: 'Могу ли я создавать танцевальные видео с ИИ бесплатно?',
                    answer: 'Да! Мы предоставляем бесплатные кредиты зарегистрированным пользователям, позволяя каждому испытать и создавать танцевальные видео с ИИ. Для пользователей, желающих удалить водяные знаки или получить качество 4K Ultra-HD, мы также предлагаем гибкие варианты обновления.',
                },
                {
                    question: 'Безопасен ли этот инструмент? Будут ли мои фото публичными?',
                    answer: 'Абсолютно безопасно. Мы строго защищаем вашу конфиденциальность. Ваши загруженные фото и созданные видео используются только для вашего процесса создания и будут безвозвратно удалены с сервера в течение определенного времени после обработки, и никогда не будут использоваться для каких-либо коммерческих целей или публичного показа.',
                },
                {
                    question: 'Какой длины танцевальное видео можно создать?',
                    answer: 'Длительность создаваемого видео обычно зависит от выбранного вами танцевального шаблона, как правило, от 5 до 30 секунд, что идеально подходит для платформ коротких видео, таких как TikTok, Instagram Reels и YouTube Shorts.',
                },
            ]
        },
        modelIntro: {
            title: 'Раскройте свой творческий потенциал, начните использовать WeryAI для создания волшебных танцевальных видео',
            description: 'Попробуйте наш генератор танцевальных видео с ИИ',
            buttonText: 'Попробуйте генератор танцевальных видео WeryAI бесплатно',
            footerText: 'Кредитная карта не требуется'
        },

        pageTitle: 'Генератор танцевальных видео с ИИ - Бесплатный создатель танцевальных видео с ИИ | WeryAI',
        pageDescription: 'Используйте генератор AI Dancing от WeryAI для создания удивительных танцевальных видео из фотографий. Поддерживает множество танцевальных шаблонов и стилей, оживите ваши фото!',
        pageKeywords: 'танцевальное видео с ИИ, генератор танцев с ИИ, фото в видео, создание видео с ИИ, WeryAI, бесплатные инструменты ИИ',
    },
    pt: {
        // Exibição da lista de efeitos de vídeo
        listTitle: 'Gerador de Vídeo de Dança IA',
        listDesc: 'Faça qualquer foto dançar ao ritmo',

        title: 'Gerador de Vídeo de Dança IA',
        description: 'Carregue uma foto, selecione um modelo e tipo de dança, e deixe a IA gerar um vídeo de dança incrível para você',
        templatePreview: 'Pré-visualização do modelo',
        noTemplateSelected: 'Por favor selecione um tipo de dança para ver o modelo',
        typesTitle: 'Selecionar tipo de dança',
        uploadTitle: 'Carregar imagem',
        uploadHint: 'Carregue fotos de retrato claras para melhores resultados',
        generateAudioLabel: 'Gerar áudio',
        generateButton: 'Gerar',
        generating: 'Gerando...',
        validation: {
            selectType: 'Por favor selecione um tipo de dança',
            uploadImage: 'Por favor carregue uma imagem',
            loginRequired: 'Por favor faça login primeiro',
        },
        featureComingSoon: 'O recurso AI Dancing chegará em breve, fique atento!',
        processingHint: 'Gerando seu vídeo de dança, por favor aguarde...',

        // Seção de introdução inferior
        introduce: {
            title: 'Gerador de Vídeo de Dança IA',
            desc: 'Faça qualquer foto dançar ao ritmo',
        },
        selectReason: {
            title: 'Por que escolher o Gerador de Vídeo de Dança WeryAI?',
            items: [
                {
                    title: 'Uma foto, "estreia" instantânea',
                    desc: 'Não é necessário equipamento de captura de movimento caro ou habilidades complexas de animação 3D. Basta carregar uma foto de corpo inteiro, e a poderosa tecnologia de ligação esquelética e repintura da WeryAI identificará automaticamente as articulações e gerará movimentos de dança suaves e naturais. Mesmo sem experiência em dança, você pode se tornar um dançarino top no vídeo.',
                },
                {
                    title: 'Movimentos de dança massivos, siga a tendência',
                    desc: 'Nossa biblioteca contém centenas de modelos de dança populares e é constantemente atualizada. De coreografia de ídolos de K-pop, Street Dance (Hip-hop), Shuffle a várias danças virais de memes, a IA ajuda você a dançar o que quiser.',
                },
                {
                    title: 'Qualquer coisa pode dançar, criatividade ilimitada',
                    desc: 'Dançar não é apenas para humanos! Você pode carregar fotos de personagens de anime, esculturas, brinquedos ou até mesmo seus animais de estimação. A WeryAI pode se adaptar inteligentemente a estruturas corporais não humanas, criando vídeos de dança hilários ou incríveis, perfeitos para conteúdo social viral.',
                },
                {
                    title: 'Movimentos precisos, detalhes realistas',
                    desc: 'Preocupado com movimentos rígidos ou rostos distorcidos? A WeryAI usa algoritmos avançados de transferência de movimento para bloquear perfeitamente as características faciais e detalhes das roupas enquanto mantém movimentos corporais em grande escala. Não importa o quão intensa seja a dança, o protagonista ainda é você, sem sensação de incongruência.',
                },
            ]
        },
        howToUse: {
            title: 'Como usar nosso Gerador de Vídeo de Dança IA?',
            desc: 'Três passos para fazer sua foto dançar',
            steps: [
                {
                    title: 'Passo 1 Carregar foto',
                    desc: 'Selecione uma foto de corpo inteiro clara (humano, anime ou animal antropomórfico), a pose de pé frontal funciona melhor.',
                },
                {
                    title: 'Passo 2 Selecionar modo',
                    desc: 'Navegue e selecione seu modelo de dança favorito (filtre por estilo ou popularidade).',
                },
                {
                    title: 'Passo 3 Gerar vídeo',
                    desc: 'Clique em Gerar, a IA extrairá automaticamente o esqueleto e realizará a transferência de movimento. Em alguns segundos, seu vídeo de dança exclusivo nasce!',
                },
            ]
        },
        exploreOthers: {
            title: 'Explore outros efeitos de vídeo populares no WeryAI',
            items: {
                kissing: 'Vídeo de Beijo IA',
                faceSwap: 'Troca de Rosto em Vídeo IA',
                anime: 'Vídeo para Anime IA',
            },
        },
        faq: {
            title: 'Perguntas frequentes',
            items: [
                {
                    question: 'O que é o Gerador de Vídeo de Dança IA?',
                    answer: 'É uma ferramenta que usa tecnologia de inteligência artificial (principalmente estimativa de pose e transferência de movimento) para converter fotos estáticas de corpo inteiro em vídeos de dança dinâmicos. Os usuários podem gerar conteúdo de vídeo de dança profissional com apenas uma imagem sem filmar.',
                },
                {
                    question: 'Que tipo de fotos são necessárias para vídeos de dança?',
                    answer: 'Para melhores resultados, recomendamos carregar uma foto de pé frontal com o corpo todo visível, bem iluminada e sem grandes obstruções. Embora fotos de meio corpo possam ser processadas, fotos de corpo inteiro permitem que os movimentos das pernas e pés sejam exibidos mais perfeitamente.',
                },
                {
                    question: 'Posso carregar meu próprio vídeo de dança como referência?',
                    answer: 'Atualmente, fornecemos principalmente modelos predefinidos ricos. Em versões futuras, abriremos o recurso "Vídeo para Vídeo (Video to Video)", permitindo que você carregue vídeos de referência para que o personagem na foto imite movimentos específicos.',
                },
                {
                    question: 'Posso gerar vídeos de dança IA gratuitamente?',
                    answer: 'Sim! Fornecemos créditos gratuitos para usuários registrados, permitindo que todos experimentem e gerem vídeos de dança IA. Para usuários que desejam remover marcas d\'água ou obter qualidade 4K ultra-HD, também oferecemos opções de atualização flexíveis.',
                },
                {
                    question: 'Esta ferramenta é segura? Minhas fotos serão públicas?',
                    answer: 'Absolutamente seguro. Protegemos rigorosamente sua privacidade. Suas fotos carregadas e vídeos gerados são usados apenas para seu processo de criação e serão excluídos permanentemente do servidor dentro de um tempo especificado após o processamento, e nunca serão usados para qualquer propósito comercial ou exibição pública.',
                },
                {
                    question: 'Qual a duração do vídeo de dança gerado?',
                    answer: 'A duração do vídeo gerado geralmente depende do modelo de dança que você escolher, geralmente entre 5 a 30 segundos, perfeito para plataformas de vídeos curtos como TikTok, Instagram Reels e YouTube Shorts.',
                },
            ]
        },
        modelIntro: {
            title: 'Liberte sua criatividade, comece a usar a WeryAI para gerar vídeos de dança mágicos',
            description: 'Experimente nosso Gerador de Vídeo de Dança IA',
            buttonText: 'Experimente o Gerador de Vídeo de Dança WeryAI gratuitamente',
            footerText: 'Não é necessário cartão de crédito'
        },

        pageTitle: 'Gerador de Vídeo de Dança IA - Criador de Vídeos de Dança IA Grátis | WeryAI',
        pageDescription: 'Use o Gerador de Dança IA da WeryAI para criar vídeos de dança incríveis a partir de fotos. Suporta vários modelos e estilos de dança, dê vida às suas fotos!',
        pageKeywords: 'vídeo de dança IA, gerador de dança IA, foto para vídeo, geração de vídeo IA, WeryAI, ferramentas de IA grátis',
    },
    it: {
        // Visualizzazione elenco effetti video
        listTitle: 'Generatore di Video di Danza AI',
        listDesc: 'Fai ballare qualsiasi foto a ritmo',

        title: 'Generatore di Video di Danza AI',
        description: 'Carica una foto, seleziona un modello e un tipo de danza, e lascia che l\'AI generi un fantastico video di danza per te',
        templatePreview: 'Anteprima del modello',
        noTemplateSelected: 'Seleziona un tipo de danza per visualizzare il modello',
        typesTitle: 'Seleziona tipo di danza',
        uploadTitle: 'Carica immagine',
        uploadHint: 'Carica foto ritratto chiare per risultati migliori',
        generateAudioLabel: 'Genera audio',
        generateButton: 'Genera',
        generating: 'Generazione...',
        validation: {
            selectType: 'Seleziona un tipo di danza',
            uploadImage: 'Carica un\'immagine',
            loginRequired: 'Effettua prima l\'accesso',
        },
        featureComingSoon: 'La funzione AI Dancing arriverà presto, restate sintonizzati!',
        processingHint: 'Generazione del tuo video di danza, attendi prego...',

        // Sezione introduttiva inferiore
        introduce: {
            title: 'Generatore di Video di Danza AI',
            desc: 'Fai ballare qualsiasi foto a ritmo',
        },
        selectReason: {
            title: 'Perché scegliere il Generatore di Video di Danza WeryAI?',
            items: [
                {
                    title: 'Una foto, "debutto" istantaneo',
                    desc: 'Non è necessaria costosa attrezzatura di motion capture o complesse abilità di animazione 3D. Basta caricare una foto a corpo intero, e la potente tecnologia di binding scheletrico e repainting di WeryAI identificherà automaticamente le articolazioni e genererà movimenti di danza fluidi e naturali. Anche senza esperienza di danza, puoi diventare un ballerino top nel video.',
                },
                {
                    title: 'Movimenti di danza massicci, segui la tendenza',
                    desc: 'La nostra libreria contiene centinaia di modelli di danza popolari ed è costantemente aggiornata. Dalla coreografia degli idoli K-pop, Street Dance (Hip-hop), Shuffle a vari balli meme virali, l\'AI ti aiuta a ballare tutto ciò che vuoi.',
                },
                {
                    title: 'Tutto può ballare, creatività illimitata',
                    desc: 'Ballare non è solo per gli umani! Puoi caricare foto di personaggi anime, sculture, giocattoli o persino i tuoi animali domestici. WeryAI può adattarsi intelligentemente a strutture corporee non umane, creando video di danza esilaranti o sorprendenti, perfetti per contenuti social virali.',
                },
                {
                    title: 'Movimenti precisi, dettagli realistici',
                    desc: 'Preoccupato per movimenti rigidi o volti distorti? WeryAI utilizza algoritmi avanzati di trasferimento del movimento per bloccare perfettamente i tratti del viso e i dettagli dell\'abbigliamento mantenendo movimenti corporei su larga scala. Non importa quanto sia intenso il ballo, il protagonista sei ancora tu, senza senso di incongruenza.',
                },
            ]
        },
        howToUse: {
            title: 'Come usare il nostro Generatore di Video di Danza AI?',
            desc: 'Tre passaggi per far ballare la tua foto',
            steps: [
                {
                    title: 'Passaggio 1 Carica foto',
                    desc: 'Seleziona una foto a corpo intero chiara (umano, anime o animale antropomorfo), la posa in piedi frontale funziona meglio.',
                },
                {
                    title: 'Passaggio 2 Seleziona modalità',
                    desc: 'Sfoglia e seleziona il tuo modello di danza preferito (filtra per stile o popolarità).',
                },
                {
                    title: 'Passaggio 3 Genera video',
                    desc: 'Fai clic su Genera, l\'AI estrarrà automaticamente lo scheletro ed eseguirà il trasferimento del movimento. In pochi secondi, nasce il tuo video di danza esclusivo!',
                },
            ]
        },
        exploreOthers: {
            title: 'Esplora altri effetti video popolari su WeryAI',
            items: {
                kissing: 'Video di Bacio AI',
                faceSwap: 'Scambio Volto Video AI',
                anime: 'Video in Anime AI',
            },
        },
        faq: {
            title: 'Domande frequenti',
            items: [
                {
                    question: 'Cos\'è il Generatore di Video di Danza AI?',
                    answer: 'È uno strumento che utilizza la tecnologia dell\'intelligenza artificiale (principalmente stima della posa e trasferimento del movimento) per convertire foto statiche a corpo intero in video di danza dinamici. Gli utenti possono generare contenuti video di danza professionali con una sola immagine senza filmare.',
                },
                {
                    question: 'Che tipo di foto sono necessarie per i video di danza?',
                    answer: 'Per i migliori risultati, consigliamo di caricare una foto in piedi frontale con tutto il corpo visibile, ben illuminata e senza grandi ostacoli. Sebbene le foto a mezzo busto possano essere elaborate, le foto a corpo intero consentono di mostrare più perfettamente i movimenti di gambe e piedi.',
                },
                {
                    question: 'Posso caricare il mio video di danza come riferimento?',
                    answer: 'Attualmente, forniamo principalmente ricchi modelli preimpostati. Nelle versioni future, apriremo la funzione "Video to Video" (Video to Video), consentendoti di caricare video di riferimento affinché il personaggio nella foto imiti movimenti specifici.',
                },
                {
                    question: 'Posso generare video di danza AI gratuitamente?',
                    answer: 'Sì! Forniamo crediti gratuiti agli utenti registrati, permettendo a tutti di provare e generare video di danza AI. Per gli utenti che desiderano rimuovere le filigrane o ottenere qualità 4K ultra-HD, offriamo anche opzioni di aggiornamento flessibili.',
                },
                {
                    question: 'Questo strumento è sicuro? Le mie foto saranno pubbliche?',
                    answer: 'Assolutamente sicuro. Proteggiamo rigorosamente la tua privacy. Le tue foto caricate e i video generati vengono utilizzati solo per il tuo processo di creazione e verranno eliminati definitivamente dal server entro un tempo specificato dopo l\'elaborazione e non verranno mai utilizzati per scopi commerciali o mostre pubbliche.',
                },
                {
                    question: 'Quanto può essere lungo il video di danza generato?',
                    answer: 'La durata del video generato dipende solitamente dal modello di danza scelto, generalmente tra 5 e 30 secondi, perfetto per piattaforme di video brevi come TikTok, Instagram Reels e YouTube Shorts.',
                },
            ]
        },
        modelIntro: {
            title: 'Scatena la tua creatività, inizia a usare WeryAI per generare video di danza magici',
            description: 'Prova il nostro Generatore di Video di Danza AI',
            buttonText: 'Prova gratuitamente il Generatore di Video di Danza WeryAI',
            footerText: 'Nessuna carta di credito richiesta'
        },

        pageTitle: 'Generatore di Video di Danza AI - Creatore di Video di Danza AI Gratuito | WeryAI',
        pageDescription: 'Usa il Generatore di Danza AI di WeryAI per creare incredibili video di danza da foto. Supporta più modelli e stili di danza, dai vita alle tue foto!',
        pageKeywords: 'video di danza AI, generatore di danza AI, foto in video, generazione video AI, WeryAI, strumenti AI gratuiti',
    },
    ar: {
        // عرض قائمة تأثيرات الفيديو
        listTitle: 'مولد فيديو الرقص بالذكاء الاصطناعي',
        listDesc: 'اجعل أي صورة ترقص على الإيقاع',

        title: 'مولد فيديو الرقص بالذكاء الاصطناعي',
        description: 'قم بتحميل صورة، واختر قالب رقص ونوعًا، ودع الذكاء الاصطناعي يولد فيديو رقص مذهل لك',
        templatePreview: 'معاينة القالب',
        noTemplateSelected: 'يرجى اختيار نوع رقص لعرض القالب',
        typesTitle: 'اختر نوع الرقص',
        uploadTitle: 'تحميل صورة',
        uploadHint: 'قم بتحميل صور شخصية واضحة للحصول على نتائج أفضل',
        generateAudioLabel: 'توليد الصوت',
        generateButton: 'توليد',
        generating: 'جاري التوليد...',
        validation: {
            selectType: 'يرجى اختيار نوع رقص',
            uploadImage: 'يرجى تحميل صورة',
            loginRequired: 'يرجى تسجيل الدخول أولاً',
        },
        featureComingSoon: 'ميزة الرقص بالذكاء الاصطناعي قادمة قريبًا، ابقوا متابعين!',
        processingHint: 'جاري توليد فيديو الرقص الخاص بك، يرجى الانتظار...',

        // قسم المقدمة السفلي
        introduce: {
            title: 'مولد فيديو الرقص بالذكاء الاصطناعي',
            desc: 'اجعل أي صورة ترقص على الإيقاع',
        },
        selectReason: {
            title: 'لماذا تختار مولد فيديو الرقص WeryAI؟',
            items: [
                {
                    title: 'صورة واحدة، "ظهور" فوري',
                    desc: 'لا حاجة لمعدات التقاط الحركة باهظة الثمن أو مهارات الرسوم المتحركة ثلاثية الأبعاد المعقدة. ما عليك سوى تحميل صورة كاملة الجسم، وستقوم تقنية ربط الهيكل العظمي وإعادة الرسم القوية من WeryAI بتحديد المفاصل تلقائيًا وتوليد حركات رقص سلسة وطبيعية. حتى بدون خبرة في الرقص، يمكنك أن تصبح راقصًا بارزًا في الفيديو.',
                },
                {
                    title: 'حركات رقص ضخمة، تابع الصيحة',
                    desc: 'تحتوي مكتبتنا على مئات قوالب الرقص الشهيرة ويتم تحديثها باستمرار. من تصميم رقصات نجوم الكيبوب، ورقص الشوارع (هيب هوب)، والشفل إلى رقصات الميم الفيروسية المختلفة، يساعدك الذكاء الاصطناعي على رقص ما تريد.',
                },
                {
                    title: 'أي شيء يمكنه الرقص، إبداع بلا حدود',
                    desc: 'الرقص ليس للبشر فقط! يمكنك تحميل صور لشخصيات الأنمي، أو المنحوتات، أو الألعاب، أو حتى حيواناتك الأليفة. يمكن لـ WeryAI التكيف بذكاء مع هياكل الجسم غير البشرية، وإنشاء مقاطع فيديو رقص مرحة أو مذهلة، مثالية للمحتوى الاجتماعي الفيروسي.',
                },
                {
                    title: 'حركات دقيقة، تفاصيل واقعية',
                    desc: 'هل تقلق بشأن الحركات المتصلبة أو الوجوه المشوهة؟ يستخدم WeryAI خوارزميات متقدمة لنقل الحركة لقفل ملامح الوجه وتفاصيل الملابس تمامًا مع الحفاظ على حركات الجسم واسعة النطاق. مهما كانت شدة الرقص، يظل البطل هو أنت، دون شعور بالتناقض.',
                },
            ]
        },
        howToUse: {
            title: 'كيف تستخدم مولد فيديو الرقص بالذكاء الاصطناعي الخاص بنا؟',
            desc: 'ثلاث خطوات لجعل صورتك ترقص',
            steps: [
                {
                    title: 'الخطوة 1 تحميل الصورة',
                    desc: 'اختر صورة كاملة الجسم واضحة (إنسان، أنمي، أو حيوان مجسم)، وضع الوقوف الأمامي يعمل بشكل أفضل.',
                },
                {
                    title: 'الخطوة 2 اختيار الوضع',
                    desc: 'تصفح واختر قالب الرقص المفضل لديك (تصفية حسب النمط أو الشعبية).',
                },
                {
                    title: 'الخطوة 3 توليد الفيديو',
                    desc: 'انقر فوق توليد، وسيقوم الذكاء الاصطناعي تلقائيًا باستخراج الهيكل العظمي وتنفيذ نقل الحركة. في بضع ثوانٍ، يولد فيديو الرقص الحصري الخاص بك!',
                },
            ]
        },
        exploreOthers: {
            title: 'استكشف تأثيرات الفيديو الشهيرة الأخرى على WeryAI',
            items: {
                kissing: 'فيديو القبلة بالذكاء الاصطناعي',
                faceSwap: 'تبديل الوجوه في الفيديو بالذكاء الاصطناعي',
                anime: 'تحويل الفيديو إلى أنمي بالذكاء الاصطناعي',
            },
        },
        faq: {
            title: 'الأسئلة الشائعة',
            items: [
                {
                    question: 'ما هو مولد فيديو الرقص بالذكاء الاصطناعي؟',
                    answer: 'إنها أداة تستخدم تقنية الذكاء الاصطناعي (بشكل أساسي تقدير الوضع ونقل الحركة) لتحويل الصور الثابتة كاملة الجسم إلى مقاطع فيديو رقص ديناميكية. يمكن للمستخدمين إنشاء محتوى فيديو رقص احترافي بصورة واحدة فقط دون تصوير.',
                },
                {
                    question: 'ما نوع الصور المطلوبة لفيديوهات الرقص؟',
                    answer: 'للحصول على أفضل النتائج، نوصي بتحميل صورة وقوف أمامية مع ظهور الجسم بالكامل، مضاءة جيدًا، وبدون عوائق كبيرة. على الرغم من إمكانية معالجة صور نصف الجسم، إلا أن صور الجسم الكامل تسمح بعرض حركات الساقين والقدمين بشكل أكثر كمالاً.',
                },
                {
                    question: 'هل يمكنني تحميل فيديو رقص خاص بي كمرجع؟',
                    answer: 'حاليًا، نقدم بشكل أساسي قوالب غنية معدة مسبقًا. في الإصدارات المستقبلية، سنفتح ميزة "فيديو إلى فيديو (Video to Video)"، مما يسمح لك بتحميل مقاطع فيديو مرجعية للشخصية في الصورة لتقليد حركات معينة.',
                },
                {
                    question: 'هل يمكنني توليد مقاطع فيديو رقص بالذكاء الاصطناعي مجانًا؟',
                    answer: 'نعم! نحن نقدم رصيدًا مجانيًا للمستخدمين المسجلين، مما يسمح للجميع بتجربة وتوليد مقاطع فيديو رقص بالذكاء الاصطناعي. بالنسبة للمستخدمين الذين يرغبون في إزالة العلامات المائية أو الحصول على جودة 4K فائقة الدقة، نقدم أيضًا خيارات ترقية مرنة.',
                },
                {
                    question: 'هل هذه الأداة آمنة؟ هل ستكون صوري عامة؟',
                    answer: 'آمنة تمامًا. نحن نحمي خصوصيتك بصرامة. يتم استخدام صورك المحملة ومقاطع الفيديو المولدة فقط لعملية الإنشاء الخاصة بك وسيتم حذفها نهائيًا من الخادم في غضون وقت محدد بعد المعالجة، ولن يتم استخدامها أبدًا لأي غرض تجاري أو عرض عام.',
                },
                {
                    question: 'ما هي مدة فيديو الرقص المولد؟',
                    answer: 'تعتمد مدة الفيديو المولد عادةً على قالب الرقص الذي تختاره، وعادة ما تتراوح بين 5 إلى 30 ثانية، وهي مثالية لمنصات الفيديو القصيرة مثل TikTok و Instagram Reels و YouTube Shorts.',
                },
            ]
        },
        modelIntro: {
            title: 'أطلق العنان لإبداعك، ابدأ باستخدام WeryAI لتوليد مقاطع فيديو رقص سحرية',
            description: 'جرب مولد فيديو الرقص بالذكاء الاصطناعي الخاص بنا',
            buttonText: 'جرب مولد فيديو الرقص WeryAI مجانًا',
            footerText: 'لا يلزم وجود بطاقة ائتمان'
        },

        pageTitle: 'مولد فيديو الرقص بالذكاء الاصطناعي - صانع فيديو رقص بالذكاء الاصطناعي مجاني | WeryAI',
        pageDescription: 'استخدم مولد الرقص بالذكاء الاصطناعي من WeryAI لإنشاء مقاطع فيديو رقص مذهلة من الصور. يدعم قوالب وأنماط رقص متعددة، ابث الحياة في صورك!',
        pageKeywords: 'فيديو رقص بالذكاء الاصطناعي، مولد رقص بالذكاء الاصطناعي، صورة إلى فيديو، توليد فيديو بالذكاء الاصطناعي، WeryAI، أدوات ذكاء اصطناعي مجانية',
        },
    th: {
        listTitle: 'เครื่องมือสร้างวิดีโอเต้น AI',
        listDesc: 'ทำให้ทุกรูปภาพเต้นตามจังหวะ',
        title: 'เครื่องมือสร้างวิดีโอเต้น AI',
        description: 'อัปโหลดรูปภาพ เลือกเทมเพลตและประเภทการเต้น แล้วให้ AI สร้างวิดีโอเต้นที่น่าทึ่งให้กับคุณ',
        templatePreview: 'ตัวอย่างเทมเพลต',
        noTemplateSelected: 'โปรดเลือกประเภทการเต้นเพื่อดูเทมเพลต',
        typesTitle: 'เลือกประเภทการเต้น',
        uploadTitle: 'อัปโหลดรูปภาพ',
        uploadHint: 'อัปโหลดรูปถ่ายพอร์ตเทรตที่ชัดเจนเพื่อผลลัพธ์ที่ดีขึ้น',
        generateAudioLabel: 'สร้างเสียง',
        generateButton: 'สร้าง',
        generating: 'กำลังสร้าง...',
        validation: {
            selectType: 'โปรดเลือกประเภทการเต้น',
            uploadImage: 'โปรดอัปโหลดรูปภาพ',
            loginRequired: 'โปรดเข้าสู่ระบบก่อน',
        },
        featureComingSoon: 'ฟีเจอร์ AI Dancing กำลังจะมาเร็วๆ นี้ โปรดติดตาม!',
        processingHint: 'กำลังสร้างวิดีโอเต้นของคุณ โปรดรอสักครู่...',
        introduce: {
            title: 'เครื่องมือสร้างวิดีโอเต้น AI',
            desc: 'ทำให้ทุกรูปภาพเต้นตามจังหวะ',
        },
        selectReason: {
            title: 'ทำไมต้องเลือก WeryAI Dancing Video Generator?',
            items: [
                {
                    title: 'รูปเดียวก็ "เดบิวต์" ได้ทันที',
                    desc: 'ไม่ต้องใช้อุปกรณ์โมชั่นแคปเจอร์ราคาแพงหรือทักษะแอนิเมชัน 3D ที่ซับซ้อน เพียงอัปโหลดรูปถ่ายเต็มตัวหนึ่งรูป เทคโนโลยี skeletal binding และ repainting ที่ทรงพลังของ WeryAI จะระบุข้อต่อโดยอัตโนมัติและสร้างการเคลื่อนไหวของการเต้นที่ลื่นไหลเป็นธรรมชาติ แม้ไม่มีพื้นฐานการเต้น คุณก็สามารถเป็นนักเต้นตัวท็อปในวิดีโอได้',
                },
                {
                    title: 'ท่าเต้นมากมาย ตามทันทุกเทรนด์',
                    desc: 'คลังของเรามีเทมเพลตการเต้นยอดนิยมหลายร้อยแบบและอัปเดตอย่างต่อเนื่อง ตั้งแต่ท่าเต้นไอดอล K-pop, Street Dance (Hip-hop), Shuffle ไปจนถึงท่าเต้นมีมไวรัลต่างๆ AI ช่วยให้คุณเต้นอะไรก็ได้ที่คุณต้องการ',
                },
                {
                    title: 'ทุกอย่างเต้นได้ ความคิดสร้างสรรค์ไร้ขีดจำกัด',
                    desc: 'การเต้นไม่ได้มีไว้สำหรับมนุษย์เท่านั้น! คุณสามารถอัปโหลดรูปภาพของตัวละครอนิเมะ ประติมากรรม ของเล่น หรือแม้แต่สัตว์เลี้ยงของคุณ WeryAI สามารถปรับให้เข้ากับโครงสร้างร่างกายที่ไม่ใช่มนุษย์ได้อย่างชาญฉลาด สร้างวิดีโอการเต้นที่สร้างสรรค์และสนุกสนาน เหมาะสำหรับเนื้อหาโซเชียลไวรัล',
                },
                {
                    title: 'การเคลื่อนไหวที่แม่นยำ รายละเอียดที่สมจริง',
                    desc: 'กังวลเกี่ยวกับการเคลื่อนไหวที่แข็งทื่อหรือใบหน้าที่ผิดเพี้ยนใช่ไหม? WeryAI ใช้อัลกอริทึมการถ่ายโอนการเคลื่อนไหวขั้นสูงเพื่อล็อคคุณสมบัติใบหน้าและรายละเอียดเสื้อผ้าได้อย่างสมบูรณ์แบบในขณะที่ยังคงการเคลื่อนไหวร่างกายขนาดใหญ่ไว้ ไม่ว่าการเต้นจะหนักหน่วงแค่ไหน ตัวเอกก็ยังเป็นคุณ โดยไม่มีความรู้สึกขัดแย้ง',
                }
            ]
        },
        howToUse: {
            title: 'วิธีใช้เครื่องมือสร้างวิดีโอเต้น AI ของเรา?',
            desc: 'สามขั้นตอนในการทำให้รูปภาพของคุณเต้นได้',
            steps: [
                {
                    title: 'ขั้นตอนที่ 1 อัปโหลดรูปภาพ',
                    desc: 'เลือกรูปถ่ายเต็มตัวที่ชัดเจน (มนุษย์ อนิเมะ หรือสัตว์ที่มีลักษณะคล้ายมนุษย์) ท่าทางยืนตรงด้านหน้าจะได้ผลดีที่สุด',
                },
                {
                    title: 'ขั้นตอนที่ 2 เลือกโหมด',
                    desc: 'เรียกดูและเลือกเทมเพลตการเต้นที่คุณชื่นชอบ (กรองตามสไตล์หรือความนิยม)',
                },
                {
                    title: 'ขั้นตอนที่ 3 สร้างวิดีโอ',
                    desc: 'คลิกสร้าง AI จะดึงโครงร่างโดยอัตโนมัติและทำการถ่ายโอนการเคลื่อนไหว ในเวลาเพียงไม่กี่วินาที วิดีโอเต้นสุดพิเศษของคุณก็จะถือกำเนิดขึ้น!',
                }
            ]
        },
        exploreOthers: {
            title: 'สำรวจเอฟเฟกต์วิดีโอยอดนิยมอื่นๆ บน WeryAI',
            items: {
                kissing: 'วิดีโอจูบ AI',
                faceSwap: 'สลับใบหน้าวิดีโอ AI',
                anime: 'วิดีโอเป็นอนิเมะ AI',
            },
        },
        faq: {
            title: 'คำถามที่พบบ่อย',
            items: [
                {
                    question: 'เครื่องมือสร้างวิดีโอเต้น AI คืออะไร?',
                    answer: 'มันคือเครื่องมือที่ใช้เทคโนโลยีปัญญาประดิษฐ์ (ส่วนใหญ่เป็นการประมาณท่าทางและการถ่ายโอนการเคลื่อนไหว) เพื่อเปลี่ยนรูปถ่ายเต็มตัวที่หยุดนิ่งให้เป็นวิดีโอเต้นที่เคลื่อนไหวได้ ผู้ใช้สามารถสร้างเนื้อหาวิดีโอการเต้นระดับมืออาชีพได้ด้วยภาพเพียงภาพเดียวโดยไม่ต้องถ่ายทำ',
                },
                {
                    question: 'ต้องใช้รูปภาพแบบไหนสำหรับวิดีโอเต้น?',
                    answer: 'เพื่อผลลัพธ์ที่ดีที่สุด เราแนะนำให้อัปโหลดรูปถ่ายยืนตรงด้านหน้าโดยให้เห็นทั้งร่างกาย มีแสงสว่างเพียงพอ และไม่มีสิ่งกีดขวางขนาดใหญ่ แม้ว่ารูปถ่ายครึ่งตัวจะสามารถประมวลผลได้ แต่รูปถ่ายเต็มตัวจะช่วยให้แสดงการเคลื่อนไหวของขาและเท้าได้อย่างสมบูรณ์แบบกว่า',
                },
                {
                    question: 'ฉันสามารถอัปโหลดวิดีโอเต้นของตัวเองเพื่อเป็นข้อมูลอ้างอิงได้หรือไม่?',
                    answer: 'ปัจจุบันเราให้บริการเทมเพลตสำเร็จรูปที่หลากหลายเป็นหลัก ในเวอร์ชันอนาคต เราจะเปิดฟีเจอร์ "Video to Video" ซึ่งจะช่วยให้คุณสามารถอัปโหลดวิดีโออ้างอิงเพื่อให้ตัวละครในรูปภาพเลียนแบบการเคลื่อนไหวที่เฉพาะเจาะจงได้',
                },
                {
                    question: 'ฉันสามารถสร้างวิดีโอเต้น AI ได้ฟรีหรือไม่?',
                    answer: 'ใช่! เรามอบเครดิตฟรีสำหรับผู้ใช้ที่ลงทะเบียน เพื่อให้ทุกคนสามารถสัมผัสและสร้างวิดีโอเต้น AI ได้ สำหรับผู้ที่ต้องการลบน้ำหมึกหรือรับคุณภาพระดับ 4K เราก็มีตัวเลือกการอัปเกรดที่ยืดหยุ่นให้',
                },
                {
                    question: 'เครื่องมือนี้ปลอดภัยหรือไม่? รูปภาพของฉันจะถูกเปิดเผยต่อสาธารณะหรือไม่?',
                    answer: 'ปลอดภัยอย่างแน่นอน เราปกป้องความเป็นส่วนตัวของคุณอย่างเคร่งครัด รูปภาพที่คุณอัปโหลดและวิดีโอที่สร้างขึ้นจะถูกใช้ในกระบวนการสร้างสรรค์ของคุณเท่านั้น และจะถูกลบออกจากเซิร์ฟเวอร์โดยสมบูรณ์ภายในเวลาที่กำหนดหลังจากประมวลผลเสร็จสิ้น จะไม่มีการนำไปใช้เพื่อวัตถุประสงค์ทางการค้าหรือนำไปแสดงต่อสาธารณะ',
                },
                {
                    question: 'สามารถสร้างวิดีโอเต้นได้นานแค่ไหน?',
                    answer: 'ความยาวของวิดีโอที่สร้างขึ้นมักจะขึ้นอยู่กับเทมเพลตการเต้นที่คุณเลือก โดยทั่วไปจะอยู่ระหว่าง 5 ถึง 30 วินาที ซึ่งเหมาะมากสำหรับการแชร์บนแพลตฟอร์มวิดีโอสั้น เช่น TikTok, Instagram Reels และ YouTube Shorts',
                }
            ]
        },
        modelIntro: {
            title: 'ปลดปล่อยความคิดสร้างสรรค์ของคุณ เริ่มใช้ WeryAI เพื่อสร้างวิดีโอเต้นที่น่าทึ่ง',
            description: 'ลองใช้เครื่องมือสร้างวิดีโอเต้น AI ของเรา',
            buttonText: 'ทดลองใช้เครื่องมือสร้างวิดีโอเต้น WeryAI ฟรี',
            footerText: 'ไม่ต้องใช้บัตรเครดิต'
        },
        pageTitle: 'เครื่องมือสร้างวิดีโอเต้น AI - โปรแกรมสร้างวิดีโอเต้น AI ฟรี | WeryAI',
        pageDescription: 'ใช้โปรแกรมสร้างวิดีโอเต้น AI ของ WeryAI เพื่อสร้างวิดีโอเต้นที่น่าทึ่งจากรูปถ่าย รองรับเทมเพลตและสไตล์ที่หลากหลาย ทำให้รูปภาพของคุณมีชีวิตชีวา!',
        pageKeywords: 'วิดีโอเต้น AI, โปรแกรมสร้างท่าเต้น AI, เปลี่ยนรูปภาพเป็นวิดีโอ, การสร้างวิดีโอ AI, WeryAI, เครื่องมือ AI ฟรี',
    },
    da: {
        listTitle: 'AI Dansevideo Generator',
        listDesc: 'Få ethvert foto til at danse til rytmen',
        title: 'AI Dansevideo Generator',
        description: 'Upload et foto, vælg en danseskabelon og type, og lad AI generere en fantastisk dansevideo til dig',
        templatePreview: 'Forhåndsvisning af skabelon',
        noTemplateSelected: 'Vælg venligst en dansetype for at se skabelonen',
        typesTitle: 'Vælg dansetype',
        uploadTitle: 'Upload billede',
        uploadHint: 'Upload klare portrætfotos for bedre resultater',
        generateAudioLabel: 'Generer lyd',
        generateButton: 'Generer',
        generating: 'Genererer...',
        validation: {
            selectType: 'Vælg venligst en dansetype',
            uploadImage: 'Upload venligst et billede',
            loginRequired: 'Log venligst ind først',
        },
        featureComingSoon: 'AI Dancing-funktionen kommer snart, hold øje!',
        processingHint: 'Genererer din dansevideo, vent venligst...',
        introduce: {
            title: 'AI Dansevideo Generator',
            desc: 'Få ethvert foto til at danse til rytmen',
        },
        selectReason: {
            title: 'Hvorfor vælge WeryAI Dansevideo Generator?',
            items: [
                {
                    title: 'Ét foto, øjeblikkelig "debut"',
                    desc: 'Intet dyrt motion capture-udstyr eller komplekse 3D-animationsevner er nødvendige. Bare upload ét fuldkropsbillede, og WeryAI\'s kraftfulde skeletal binding- og repainting-teknologi vil automatisk identificere led og generere glatte, naturlige dansebevægelser. Selv uden dansebaggrund kan du blive en topdanser i videoen.',
                },
                {
                    title: 'Massive dansetrin, følg trenden',
                    desc: 'Vores bibliotek indeholder hundredvis af populære danseskabeloner og opdateres konstant. Fra K-pop idol-koreografi, Street Dance (Hip-hop), Shuffle til diverse virale Meme-danse, AI hjælper dig med at danse, hvad du vil.',
                },
                {
                    title: 'Alt kan danse, grænseløs kreativitet',
                    desc: 'Dans er ikke kun for mennesker! Du kan uploade fotos af animefigurer, skulpturer, legetøj eller endda dine kæledyr. WeryAI kan intelligent tilpasse sig ikke-menneskelige kropsstrukturer og skabe hylende morsomme eller fantastiske kreative dansevideoer, perfekt til viralt socialt indhold.',
                },
                {
                    title: 'Præcise bevægelser, realistiske detaljer',
                    desc: 'Bekymret for stive bevægelser eller forvrængede ansigter? WeryAI bruger avancerede motion transfer-algoritmer til at låse ansigtstræk og tøjdetaljer perfekt, mens store kropsbevægelser opretholdes. Uanset hvor intens dansen er, er hovedpersonen stadig dig, uden følelse af uoverensstemmelse.',
                }
            ]
        },
        howToUse: {
            title: 'Hvordan bruger man vores AI Dansevideo Generator?',
            desc: 'Tre trin til at få dit foto til at danse',
            steps: [
                {
                    title: 'Trin 1 Upload foto',
                    desc: 'Vælg et klart fuldkropsbillede (menneske, anime eller menneskelignende dyr), frontstående positur virker bedst.',
                },
                {
                    title: 'Trin 2 Vælg tilstand',
                    desc: 'Gennemse og vælg din favorit danseskabelon (filtrer efter stil eller popularitet).',
                },
                {
                    title: 'Trin 3 Generer video',
                    desc: 'Klik på Generer, AI vil automatisk udtrække skelet og udføre motion transfer. På få sekunder er din eksklusive dansevideo født!',
                }
            ]
        },
        exploreOthers: {
            title: 'Udforsk andre populære videoeffekter på WeryAI',
            items: {
                kissing: 'AI Kyssevideo',
                faceSwap: 'AI Video Ansigtsudskiftning',
                anime: 'AI Video til Anime',
            },
        },
        faq: {
            title: 'Ofte stillede spørgsmål',
            items: [
                {
                    question: 'Hvad er AI Dansevideo Generator?',
                    answer: 'Det er et værktøj, der bruger kunstig intelligens-teknologi (hovedsageligt posestimering og motion transfer) til at konvertere statiske fuldkropsbilleder til dynamiske dansevideoer. Brugere kan generere professionelt dansevideoindhold med kun ét billede uden optagelse.',
                },
                {
                    question: 'Hvilken slags fotos er nødvendige for dansevideoer?',
                    answer: 'For de bedste resultater anbefaler vi at uploade et frontstående foto med hele kroppen synlig, godt oplyst og uden store forhindringer. Selvom halv kropsbilleder kan behandles, tillader fuldkropsbilleder, at ben- og fodbevægelser vises mere perfekt.',
                },
                {
                    question: 'Kan jeg uploade min egen dansevideo som reference?',
                    answer: 'I øjeblikket tilbyder vi primært et rigt udvalg af forudindstillede skabeloner. I fremtidige versioner vil vi åbne funktionen "Video til Video", som gør det muligt for dig at uploade referencevideoer, så karakteren på billedet kan efterligne specifikke bevægelser.',
                },
                {
                    question: 'Kan jeg generere AI-dansevideoer gratis?',
                    answer: 'Ja! Vi giver gratis point til registrerede brugere, så alle kan opleve og generere AI-dansevideoer. For dem, der ønsker at fjerne vandmærke eller få 4K-kvalitet, tilbyder vi fleksible opgraderingsmuligheder.',
                },
                {
                    question: 'Er dette værktøj sikkert? Vil mine fotos være offentlige?',
                    answer: 'Absolut sikkert. Vi beskytter dit privatliv strengt. Dine uploadede fotos og genererede videoer bruges kun i din skabelsesproces og slettes fuldstændigt fra serverne inden for en bestemt tid efter behandlingen. De vil aldrig blive brugt til kommercielle formål eller vist offentligt.',
                },
                {
                    question: 'Hvor lange dansevideoer kan man generere?',
                    answer: 'Længden på den genererede video afhænger normalt af den danseskabelon, du vælger, typisk mellem 5 og 30 sekunder, hvilket er ideelt til deling på korte videoplatforme som TikTok, Instagram Reels og YouTube Shorts.',
                }
            ]
        },
        modelIntro: {
            title: 'Slip din kreativitet løs, begynd at bruge WeryAI til at generere magiske dansevideoer',
            description: 'Prøv vores AI Dansevideo Generator',
            buttonText: 'Prøv WeryAI Dansevideo Generator gratis',
            footerText: 'Intet kreditkort påkrævet'
        },
        pageTitle: 'AI Dansevideo Generator - Gratis AI Dansevideo Maker | WeryAI',
        pageDescription: 'Brug WeryAIs AI Dansevideo Generator til at skabe fantastiske dansevideoer fra fotos. Understøtter flere skabeloner og stilarter, giv dine fotos liv!',
        pageKeywords: 'AI dansevideo, AI dansegenerator, foto til video, AI videogenerering, WeryAI, gratis AI værktøjer',
    },
    no: {
        listTitle: 'AI Dansevideogenerator',
        listDesc: 'Få ethvert bilde til å danse til rytmen',
        title: 'AI Dansevideogenerator',
        description: 'Last opp et bilde, velg en dansemal og type, og la AI generere en fantastisk dansevideo for deg',
        templatePreview: 'Forhåndsvisning av mal',
        noTemplateSelected: 'Vennligst velg en dansetype for å se malen',
        typesTitle: 'Velg dansetype',
        uploadTitle: 'Last opp bilde',
        uploadHint: 'Last opp klare portrettbilder for bedre resultater',
        generateAudioLabel: 'Generer lyd',
        generateButton: 'Generer',
        generating: 'Genererer...',
        validation: {
            selectType: 'Vennligst velg en dansetype',
            uploadImage: 'Vennligst last opp et bilde',
            loginRequired: 'Vennligst logg inn først',
        },
        featureComingSoon: 'AI Dancing-funksjonen kommer snart, følg med!',
        processingHint: 'Genererer din dansevideo, vennligst vent...',
        introduce: {
            title: 'AI Dansevideogenerator',
            desc: 'Få ethvert bilde til å danse til rytmen',
        },
        selectReason: {
            title: 'Hvorfor velge WeryAI Dansevideogenerator?',
            items: [
                {
                    title: 'Ett bilde, umiddelbar "debut"',
                    desc: 'Ingen dyrt utstyr for bevegelsesopptak eller komplekse 3D-animasjonsferdigheter er nødvendig. Bare last opp ett fullkroppsbilde, og WeryAIs kraftige skeletal binding- og repainting-teknologi vil automatisk identifisere ledd og generere glatte, naturlige dansebevegelser. Selv uten dansebakgrunn kan du bli en toppdanser i videoen.',
                },
                {
                    title: 'Enorme mengder dansetrinn, følg trenden',
                    desc: 'Biblioteket vårt inneholder hundrevis av populære dansemaler og oppdateres kontinuerlig. Fra K-pop idol-koreografi, Street Dance (Hip-hop), Shuffle til diverse virale Meme-danser, AI hjelper deg å danse hva du vil.',
                },
                {
                    title: 'Alt kan danse, grenseløs kreativitet',
                    desc: 'Dans er ikke bare for mennesker! Du kan laste opp bilder av anime-figurer, skulpturer, leker eller til og med kjæledyrene dine. WeryAI kan intelligent tilpasse seg ikke-menneskelige kroppsstrukturer og skape hylende morsomme eller fantastiske kreative dansevideoer, perfekt for viralt sosialt innhold.',
                },
                {
                    title: 'Presise bevegelser, realistiske detaljer',
                    desc: 'Bekymret for stive bevegelser eller forvrengte ansikter? WeryAI bruker avanserte motion transfer-algoritmer for å låse ansiktstrekk og klesdetaljer perfekt mens store kroppsbevegelser opprettholdes. Uanset hvor intens dansen er, er hovedpersonen fortsatt deg, uten følelse av uoverensstemmelse.',
                }
            ]
        },
        howToUse: {
            title: 'Hvordan bruke vår AI Dansevideogenerator?',
            desc: 'Tre steg for å få bildet ditt til å danse',
            steps: [
                {
                    title: 'Steg 1 Last opp bilde',
                    desc: 'Velg et klart fullkroppsbilde (menneske, anime eller menneskelignende dyr), frontstående positur fungerer best.',
                },
                {
                    title: 'Steg 2 Velg modus',
                    desc: 'Bla gjennom og velg din favoritt dansemal (filtrer etter stil eller popularitet).',
                },
                {
                    title: 'Steg 3 Generer video',
                    desc: 'Klikk på Generer, AI vil automatisk trekke ut skjelettet og utføre motion transfer. På få sekunder er din eksklusive dansevideo født!',
                }
            ]
        },
        exploreOthers: {
            title: 'Utforsk andre populære videoeffekter på WeryAI',
            items: {
                kissing: 'AI Kyssvideo',
                faceSwap: 'AI Video Ansiktsbytte',
                anime: 'AI Video til Anime',
            },
        },
        faq: {
            title: 'Ofte stilte spørsmål',
            items: [
                {
                    question: 'Hva er AI Dansevideogenerator?',
                    answer: 'Det er et verktøy som bruker kunstig intelligens-teknologi (hovedsakelig posestimering og motion transfer) for å konvertere statiske fullkroppsbilder til dynamiske dansevideoer. Brukere kan generere profesjonelt dansevideoinnhold med bare ett bilde uten opptak.',
                },
                {
                    question: 'Hva slags bilder trengs for dansevideoer?',
                    answer: 'For best resultat anbefaler vi å laste opp et frontstående bilde med hele kroppen synlig, godt opplyst og uten store hindringer. Selv om halvkroppsbilder kan behandles, tillater fullkroppsbilder at ben- og fotbevegelser vises mer perfekt.',
                },
                {
                    question: 'Kan jeg laste opp min egen dansevideo som referanse?',
                    answer: 'For øyeblikket tilbyr vi primært et rikt utvalg av forhåndsinnstilte maler. I fremtidige versjoner vil vi åpne funksjonen "Video til Video", som gjør det mulig for deg å laste opp referansevideoer slik at karakteren på bildet kan etterligne spesifikke bevegelser.',
                },
                {
                    question: 'Kan jeg generere AI-dansevideoer gratis?',
                    answer: 'Ja! Vi gir gratis poeng til registrerte brukere, slik at alle kan oppleve og generere AI-dansevideoer. For de som ønsker å fjerne vannmerke eller få 4K-kvalitet, tilbyr vi fleksible oppgraderingsmuligheter.',
                },
                {
                    question: 'Er dette verktøyet sikkert? Vil bildene mine være offentlige?',
                    answer: 'Absolutt sikkert. Vi beskytter ditt personvern strengt. Opplastede bilder og genererte videoer brukes kun i din skapelsesprosess og slettes fullstendig fra serverne innen en bestemt tid etter behandlingen. De vil aldri bli brukt til kommersielle formål eller vist offentlig.',
                },
                {
                    question: 'Hvor lange dansevideoer kan man generere?',
                    answer: 'Lengden på den genererte videoen avhenger normalt av dansemalen du velger, vanligvis mellom 5 og 30 sekunder, noe som er ideelt for deling på korte videoplattformer som TikTok, Instagram Reels og YouTube Shorts.',
                }
            ]
        },
        modelIntro: {
            title: 'Slipp kreativiteten løs, begynn å bruke WeryAI for å generere magiske dansevideoer',
            description: 'Prøv vår AI Dansevideogenerator',
            buttonText: 'Prøv WeryAI Dansevideogenerator gratis',
            footerText: 'Ingen kredittkort kreves'
        },
        pageTitle: 'AI Dansevideogenerator - Gratis AI Dansevideomaker | WeryAI',
        pageDescription: 'Bruk WeryAIs AI Dansevideogenerator for å lage fantastiske dansevideoer fra bilder. Støtter flere maler og stiler, gi bildene dine liv!',
        pageKeywords: 'AI dansevideo, AI dansegenerator, bilde til video, AI videogenerering, WeryAI, gratis AI-verktøy',
    },
    nl: {
        listTitle: 'AI-dansvideogenerator',
        listDesc: 'Laat elke foto dansen op het ritme',
        title: 'AI-dansvideogenerator',
        description: 'Upload een foto, selecteer een danssjabloon en type, en laat AI een geweldige dansvideo voor je genereren',
        templatePreview: 'Voorbeeld sjabloon',
        noTemplateSelected: 'Selecteer een danstype om het sjabloon te bekijken',
        typesTitle: 'Selecteer danstype',
        uploadTitle: 'Afbeelding uploaden',
        uploadHint: 'Upload duidelijke portretfoto\'s voor betere resultaten',
        generateAudioLabel: 'Geluid genereren',
        generateButton: 'Genereren',
        generating: 'Genereren...',
        validation: {
            selectType: 'Selecteer een danstype',
            uploadImage: 'Upload een afbeelding',
            loginRequired: 'Log eerst in',
        },
        featureComingSoon: 'AI Dancing-functie komt binnenkort, blijf op de hoogte!',
        processingHint: 'Je dansvideo wordt gegenereerd, even geduld...',
        introduce: {
            title: 'AI-dansvideogenerator',
            desc: 'Laat elke foto dansen op het ritme',
        },
        selectReason: {
            title: 'Waarom kiezen voor de WeryAI-dansvideogenerator?',
            items: [
                {
                    title: 'Eén foto, direct "debuut"',
                    desc: 'Geen dure motion capture-apparatuur of complexe 3D-animatievaardigheden nodig. Upload gewoon één foto van je volledige lichaam en de krachtige technologie van WeryAI identificeert automatisch gewrichten en genereert soepele, natuurlijke dansbewegingen. Zelfs zonder danservaring kun je een topdanser worden in de video.',
                },
                {
                    title: 'Enorm veel danspassen, volg de trend',
                    desc: 'Onze bibliotheek bevat honderden populaire danssjablonen en wordt constant bijgewerkt. Van K-pop choreografieën, Street Dance (Hip-hop), Shuffle tot diverse virale Meme-dansen, AI helpt je te dansen wat je maar wilt.',
                },
                {
                    title: 'Alles kan dansen, grenzeloze creativiteit',
                    desc: 'Dansen is niet alleen voor mensen! Je kunt foto\'s uploaden van anime-personages, sculpturen, speelgoed of zelfs je huisdieren. WeryAI kan zich intelligent aanpassen aan niet-menselijke lichaamsstructuren en hilarische of verbazingwekkende creatieve dansvideo\'s maken, perfect voor virale social content.',
                },
                {
                    title: 'Nauwkeurige bewegingen, realistische details',
                    desc: 'Bezorgd over stijve bewegingen of vervormde gezichten? WeryAI gebruikt geavanceerde bewegingsoverdracht-algoritmen om gezichtskenmerken en kledingdetails perfect te vergrendelen terwijl grote lichaamsbewegingen behouden blijven. Hoe intens de dans ook is, de hoofdpersoon ben jij nog steeds, zonder gevoel van onnatuurlijkheid.',
                }
            ]
        },
        howToUse: {
            title: 'Hoe gebruik je onze AI-dansvideogenerator?',
            desc: 'Drie stappen om je foto te laten dansen',
            steps: [
                {
                    title: 'Stap 1 Foto uploaden',
                    desc: 'Selecteer een duidelijke foto van je volledige lichaam (mens, anime of antropomorf dier), een staande pose van voren werkt het best.',
                },
                {
                    title: 'Stap 2 Modus selecteren',
                    desc: 'Blader door en selecteer je favoriete danssjabloon (filter op stijl of populariteit).',
                },
                {
                    title: 'Stap 3 Video genereren',
                    desc: 'Klik op Genereren, AI extraheert automatisch het skelet en voert de bewegingsoverdracht uit. In enkele seconden is je exclusieve dansvideo geboren!',
                }
            ]
        },
        exploreOthers: {
            title: 'Ontdek andere populaire video-effecten op WeryAI',
            items: {
                kissing: 'AI-kusvideo',
                faceSwap: 'AI-video gezichtswissel',
                anime: 'AI-video naar anime',
            },
        },
        faq: {
            title: 'Veelgestelde vragen',
            items: [
                {
                    question: 'Wat is de AI-dansvideogenerator?',
                    answer: 'Het is een tool die kunstmatige intelligentie gebruikt (voornamelijk pose-schatting en bewegingsoverdracht) om statische foto\'s van het volledige lichaam om te zetten in dynamische dansvideo\'s. Gebruikers kunnen professionele dansvideo-content genereren met slechts één afbeelding zonder te filmen.',
                },
                {
                    question: 'Wat voor foto\'s zijn nodig voor dansvideo\'s?',
                    answer: 'Voor de beste resultaten raden we aan om een staande foto van voren te uploaden waarbij het hele lichaam zichtbaar is, goed verlicht en zonder grote obstakels. Hoewel halve lichaamsfoto\'s kunnen worden verwerkt, zorgen foto\'s van het volledige lichaam ervoor dat been- en voetbewegingen perfect worden weergegeven.',
                },
                {
                    question: 'Kan ik mijn eigen dansvideo uploaden als referentie?',
                    answer: 'Momenteel bieden we voornamelijk een rijke selectie aan vooraf ingestelde sjablonen. In toekomstige versies zullen we de functie "Video naar Video" openen, waarmee je referentievideo\'s kunt uploaden zodat het personage op de foto specifieke bewegingen kan nabootsen.',
                },
                {
                    question: 'Kan ik AI-dansvideo\'s gratis genereren?',
                    answer: 'Ja! We geven gratis punten aan geregistreerde gebruikers, zodat iedereen AI-dansvideo\'s kan ervaren en genereren. Voor degenen die het watermerk willen verwijderen of 4K-kwaliteit willen, bieden we flexibele upgrade-opties.',
                },
                {
                    question: 'Is deze tool veilig? Worden mijn foto\'s openbaar?',
                    answer: 'Absoluut veilig. We beschermen je privacy strikt. Je geüploade foto\'s en gegenereerde video\'s worden alleen gebruikt in je creatieproces en worden binnen een bepaalde tijd na verwerking volledig van de servers verwijderd. Ze worden nooit gebruikt voor commerciële doeleinden of openbaar getoond.',
                },
                {
                    question: 'Hoe lange dansvideo\'s kun je genereren?',
                    answer: 'De lengte van de gegenereerde video hangt meestal af van het danssjabloon dat je kiest, doorgaans tussen de 5 en 30 seconden, wat ideaal is voor het delen op korte videoplatforms zoals TikTok, Instagram Reels en YouTube Shorts.',
                }
            ]
        },
        modelIntro: {
            title: 'Ontketen je creativiteit, begin met het gebruik van WeryAI om magische dansvideo\'s te genereren',
            description: 'Probeer onze AI-dansvideogenerator',
            buttonText: 'Probeer WeryAI-dansvideogenerator gratis',
            footerText: 'Geen creditcard vereist'
        },
        pageTitle: 'AI-dansvideogenerator - Gratis AI-dansvideomaker | WeryAI',
        pageDescription: 'Gebruik de AI-dansvideogenerator van WeryAI om geweldige dansvideo\'s te maken van foto\'s. Ondersteunt meerdere sjablonen en stijlen, breng je foto\'s tot leven!',
        pageKeywords: 'AI-dansvideo, AI-dansgenerator, foto naar video, AI-videogeneratie, WeryAI, gratis AI-tools',
    },
    id: {
        listTitle: 'Generator Video Tari AI',
        listDesc: 'Buat foto apa pun menari mengikuti ritme',
        title: 'Generator Video Tari AI',
        description: 'Unggah foto, pilih templat dan jenis tarian, dan biarkan AI menghasilkan video tarian yang menakjubkan untuk Anda',
        templatePreview: 'Pratinjau Templat',
        noTemplateSelected: 'Silakan pilih jenis tarian untuk melihat templat',
        typesTitle: 'Pilih Jenis Tarian',
        uploadTitle: 'Unggah Gambar',
        uploadHint: 'Unggah foto potret yang jelas untuk hasil yang lebih baik',
        generateAudioLabel: 'Hasilkan Audio',
        generateButton: 'Hasilkan',
        generating: 'Menghasilkan...',
        validation: {
            selectType: 'Silakan pilih jenis tarian',
            uploadImage: 'Silakan unggah gambar',
            loginRequired: 'Silakan masuk terlebih dahulu',
        },
        featureComingSoon: 'Fitur AI Dancing segera hadir, pantau terus!',
        processingHint: 'Menghasilkan video tarian Anda, mohon tunggu...',
        introduce: {
            title: 'Generator Video Tari AI',
            desc: 'Buat foto apa pun menari mengikuti ritme',
        },
        selectReason: {
            title: 'Mengapa memilih Generator Video Tari WeryAI?',
            items: [
                {
                    title: 'Satu foto, langsung "debut"',
                    desc: 'Tidak perlu peralatan motion capture yang mahal atau keahlian animasi 3D yang rumit. Cukup unggah satu foto seluruh tubuh, dan teknologi skeletal binding dan repainting WeryAI yang kuat akan secara otomatis mengidentifikasi sendi dan menghasilkan gerakan tari yang halus dan alami. Bahkan tanpa latar belakang menari, Anda bisa menjadi penari top dalam video.',
                },
                {
                    title: 'Banyak gerakan tari, ikuti tren',
                    desc: 'Perpustakaan kami berisi ratusan templat tarian populer dan terus diperbarui. Dari koreografi idola K-pop, Street Dance (Hip-hop), Shuffle hingga berbagai tarian Meme viral, AI membantu Anda menari apa pun yang Anda inginkan.',
                },
                {
                    title: 'Apa pun bisa menari, kreativitas tanpa batas',
                    desc: 'Menari bukan hanya untuk manusia! Anda dapat mengunggah foto karakter anime, patung, mainan, atau bahkan hewan peliharaan Anda. WeryAI dapat beradaptasi secara cerdas dengan struktur tubuh non-manusia, membuat video tarian kreatif yang lucu atau menakjubkan, cocok untuk konten sosial viral.',
                },
                {
                    title: 'Gerakan presisi, detail realistis',
                    desc: 'Khawatir tentang gerakan kaku atau wajah yang terdistorsi? WeryAI menggunakan algoritma transfer gerakan tingkat lanjut untuk mengunci fitur wajah dan detail pakaian dengan sempurna sambil mempertahankan gerakan tubuh skala besar. Seberapa pun intens tariannya, protagonisnya tetap Anda, tanpa rasa tidak wajar.',
                }
            ]
        },
        howToUse: {
            title: 'Bagaimana cara menggunakan Generator Video Tari AI kami?',
            desc: 'Tiga langkah untuk membuat foto Anda menari',
            steps: [
                {
                    title: 'Langkah 1 Unggah Foto',
                    desc: 'Pilih foto seluruh tubuh yang jelas (manusia, anime, atau hewan antropomorfik), pose berdiri menghadap depan memberikan hasil terbaik.',
                },
                {
                    title: 'Langkah 2 Pilih Mode',
                    desc: 'Jelajahi dan pilih templat tarian favorit Anda (filter berdasarkan gaya atau popularitas).',
                },
                {
                    title: 'Langkah 3 Hasilkan Video',
                    desc: 'Klik Hasilkan, AI akan secara otomatis mengekstrak kerangka dan melakukan transfer gerakan. Dalam hitungan detik, video tarian eksklusif Anda lahir!',
                }
            ]
        },
        exploreOthers: {
            title: 'Jelajahi efek video populer lainnya di WeryAI',
            items: {
                kissing: 'Video Ciuman AI',
                faceSwap: 'Tukar Wajah Video AI',
                anime: 'Video ke Anime AI',
            },
        },
        faq: {
            title: 'Pertanyaan yang Sering Diajukan',
            items: [
                {
                    question: 'Apa itu Generator Video Tari AI?',
                    answer: 'Ini adalah alat yang menggunakan teknologi kecerdasan buatan (terutama estimasi pose dan transfer gerakan) untuk mengubah foto seluruh tubuh yang statis menjadi video tarian yang dinamis. Pengguna dapat menghasilkan konten video tari profesional hanya dengan satu gambar tanpa perlu syuting.',
                },
                {
                    question: 'Jenis foto apa yang dibutuhkan untuk video tarian?',
                    answer: 'Untuk hasil terbaik, kami menyarankan untuk mengunggah foto berdiri menghadap depan dengan seluruh tubuh terlihat, pencahayaan yang baik, dan tanpa halangan besar. Meskipun foto setengah badan dapat diproses, foto seluruh tubuh memungkinkan gerakan kaki dan kaki ditampilkan lebih sempurna.',
                },
                {
                    question: 'Bisakah saya mengunggah video tarian saya sendiri sebagai referensi?',
                    answer: 'Saat ini kami terutama menyediakan berbagai pilihan templat preset. Dalam versi mendatang, kami akan membuka fitur "Video to Video", yang memungkinkan Anda mengunggah video referensi agar karakter dalam foto dapat meniru gerakan tertentu.',
                },
                {
                    question: 'Bisakah saya menghasilkan video tari AI secara gratis?',
                    answer: 'Ya! Kami memberikan kredit gratis bagi pengguna terdaftar, sehingga setiap orang dapat mencoba dan menghasilkan video tari AI. Bagi mereka yang ingin menghapus tanda air atau mendapatkan kualitas 4K, kami menawarkan opsi peningkatan yang fleksibel.',
                },
                {
                    question: 'Apakah alat ini aman? Apakah foto saya akan dipublikasikan?',
                    answer: 'Sangat aman. Kami menjaga privasi Anda dengan ketat. Foto yang Anda unggah dan video yang dihasilkan hanya digunakan dalam proses pembuatan Anda, dan akan dihapus sepenuhnya dari server dalam waktu tertentu setelah pemrosesan. Tidak akan pernah digunakan untuk tujuan komersial atau ditampilkan secara publik.',
                },
                {
                    question: 'Seberapa panjang video tari yang bisa dihasilkan?',
                    answer: 'Panjang video yang dihasilkan biasanya tergantung pada templat tarian yang Anda pilih, umumnya antara 5 hingga 30 detik, yang sangat ideal untuk dibagikan di platform video pendek seperti TikTok, Instagram Reels, dan YouTube Shorts.',
                }
            ]
        },
        modelIntro: {
            title: 'Lepaskan kreativitas Anda, mulailah menggunakan WeryAI untuk menghasilkan video tarian yang ajaib',
            description: 'Coba Generator Video Tari AI kami',
            buttonText: 'Coba Generator Video Tari WeryAI Gratis',
            footerText: 'Tidak perlu kartu kredit'
        },
        pageTitle: 'Generator Video Tari AI - Pembuat Video Tari AI Gratis | WeryAI',
        pageDescription: 'Gunakan Generator Video Tari AI WeryAI untuk membuat video tarian menakjubkan dari foto. Mendukung banyak templat dan gaya, hidupkan foto Anda!',
        pageKeywords: 'Video tari AI, generator tari AI, foto ke video, pembuatan video AI, WeryAI, alat AI gratis',
    },
    tr: {
        listTitle: 'Yapay Zeka Dans Videosu Üreticisi',
        listDesc: 'Herhangi bir fotoğrafın ritme göre dans etmesini sağlayın',
        title: 'Yapay Zeka Dans Videosu Üreticisi',
        description: 'Bir fotoğraf yükleyin, bir dans şablonu ve türü seçin ve yapay zekanın sizin için harika bir dans videosu oluşturmasına izin verin',
        templatePreview: 'Şablon Önizlemesi',
        noTemplateSelected: 'Şablonu görüntülemek için lütfen bir dans türü seçin',
        typesTitle: 'Dans Türü Seçin',
        uploadTitle: 'Görsel Yükle',
        uploadHint: 'Daha iyi sonuçlar için net portre fotoğrafları yükleyin',
        generateAudioLabel: 'Ses Oluştur',
        generateButton: 'Oluştur',
        generating: 'Oluşturuluyor...',
        validation: {
            selectType: 'Lütfen bir dans türü seçin',
            uploadImage: 'Lütfen bir görsel yükleyin',
            loginRequired: 'Lütfen önce giriş yapın',
        },
        featureComingSoon: 'AI Dancing özelliği yakında geliyor, takipte kalın!',
        processingHint: 'Dans videonuz oluşturuluyor, lütfen bekleyin...',
        introduce: {
            title: 'Yapay Zeka Dans Videosu Üreticisi',
            desc: 'Herhangi bir fotoğrafın ritme göre dans etmesini sağlayın',
        },
        selectReason: {
            title: 'Neden WeryAI Dans Videosu Üreticisini Seçmelisiniz?',
            items: [
                {
                    title: 'Tek bir fotoğraf, anında "çıkış"',
                    desc: 'Pahalı hareket yakalama ekipmanlarına veya karmaşık 3D animasyon becerilerine gerek yok. Sadece tam boy bir fotoğraf yükleyin; WeryAI\'nın güçlü iskelet bağlama ve yeniden boyama teknolojisi eklemleri otomatik olarak tanımlayacak ve akıcı, doğal dans hareketleri oluşturacaktır. Dans geçmişiniz olmasa bile videoda en iyi dansçılardan biri olabilirsiniz.',
                },
                {
                    title: 'Muazzam dans hareketleri, trendi takip edin',
                    desc: 'Kütüphanemiz yüzlerce popüler dans şablonu içerir ve sürekli güncellenir. K-pop idol koreografilerinden Street Dance (Hip-hop), Shuffle ve çeşitli viral Meme danslarına kadar, yapay zeka istediğiniz her şeyi dans etmenize yardımcı olur.',
                },
                {
                    title: 'Her şey dans edebilir, sınırsız yaratıcılık',
                    desc: 'Dans etmek sadece insanlar için değildir! Anime karakterlerinin, heykellerin, oyuncakların ve hatta evcil hayvanlarınızın fotoğraflarını yükleyebilirsiniz. WeryAI, insan dışı vücut yapılarına akıllıca uyum sağlayabilir; viral sosyal içerikler için mükemmel, komik veya şaşırtıcı yaratıcı dans videoları oluşturabilir.',
                },
                {
                    title: 'Hassas hareketler, gerçekçi detaylar',
                    desc: 'Sert hareketler veya bozulmuş yüzler konusunda endişeli misiniz? WeryAI, büyük ölçekli vücut hareketlerini korurken yüz özelliklerini ve kıyafet detaylarını mükemmel bir şekilde kilitlemek için gelişmiş hareket aktarım algoritmaları kullanır. Dans ne kadar yoğun olursa olsun, başrol hala sizsiniz; hiçbir uyumsuzluk hissi yaratmaz.',
                }
            ]
        },
        howToUse: {
            title: 'Yapay Zeka Dans Videosu Üreticimiz nasıl kullanılır?',
            desc: 'Fotoğrafınızı dans ettirmek için üç adım',
            steps: [
                {
                    title: 'Adım 1 Fotoğraf Yükle',
                    desc: 'Net bir tam boy fotoğraf seçin (insan, anime veya antropomorfik hayvan), önden duruş en iyi sonucu verir.',
                },
                {
                    title: 'Adım 2 Mod Seç',
                    desc: 'Favori dans şablonunuza göz atın ve seçin (tarza veya popülerliğe göre filtreleyin).',
                },
                {
                    title: 'Adım 3 Video Oluştur',
                    desc: 'Oluştur\'a tıklayın, yapay zeka otomatik olarak iskeleti çıkaracak ve hareket aktarımını gerçekleştirecektir. Birkaç saniye içinde size özel dans videonuz doğacak!',
                }
            ]
        },
        exploreOthers: {
            title: 'WeryAI\'daki diğer popüler video efektlerini keşfedin',
            items: {
                kissing: 'Yapay Zeka Öpücük Videosu',
                faceSwap: 'Yapay Zeka Video Yüz Değiştirme',
                anime: 'Yapay Zeka Videodan Animeye',
            },
        },
        faq: {
            title: 'Sıkça Sorulan Sorular',
            items: [
                {
                    question: 'Yapay Zeka Dans Videosu Üreticisi nedir?',
                    answer: 'Statik tam boy fotoğrafları dinamik dans videolarına dönüştürmek için yapay zeka teknolojisini (esas olarak poz tahmini ve hareket aktarımı) kullanan bir araçtır. Kullanıcılar, çekim yapmaya gerek kalmadan sadece tek bir görselle profesyonel dans videosu içerikleri oluşturabilirler.',
                },
                {
                    question: 'Dans videoları için ne tür fotoğraflar gereklidir?',
                    answer: 'En iyi sonuçlar için, tüm vücudun göründüğü, iyi aydınlatılmış ve büyük engeller içermeyen önden duran bir tam boy fotoğraf yüklemenizi öneririz. Yarım boy fotoğraflar işlenebilse de, tam boy fotoğraflar bacak ve ayak hareketlerinin daha kusursuz bir şekilde görüntülenmesini sağlar.',
                },
                {
                    question: 'Referans olarak kendi dans videomu yükleyebilir miyim?',
                    answer: 'Şu anda temel olarak zengin bir hazır şablon seçeneği sunuyoruz. Gelecekteki sürümlerde, fotoğraftaki karakterin belirli hareketleri taklit edebilmesi için referans videolar yüklemenize olanak tanıyan "Video to Video" özelliğini açacağız.',
                },
                {
                    question: 'Yapay zeka dans videolarını ücretsiz oluşturabilir miyim?',
                    answer: 'Evet! Kayıtlı kullanıcılara ücretsiz kredi veriyoruz, böylece herkes yapay zeka dans videolarını deneyimleyebilir ve oluşturabilir. Filigranı kaldırmak veya 4K kalite elde etmek isteyenler için esnek yükseltme seçenekleri sunuyoruz.',
                },
                {
                    question: 'bu araç güvenli mi? Fotoğraflarım herkese açık olacak mı?',
                    answer: 'Kesinlikle güvenli. Gizliliğinizi sıkı bir şekilde koruyoruz. Yüklediğiniz fotoğraflar ve oluşturulan videolar yalnızca oluşturma sürecinizde kullanılır ve işleme tamamlandıktan sonra belirli bir süre içinde sunuculardan tamamen silinir. Asla ticari amaçlarla kullanılmaz veya herkese açık olarak sergilenmez.',
                },
                {
                    question: 'Ne kadar uzunlukta dans videoları oluşturulabilir?',
                    answer: 'Oluşturulan videonun uzunluğu genellikle seçtiğiniz dans şablonuna bağlıdır; genellikle 5 ile 30 saniye arasındadır ve TikTok, Instagram Reels ve YouTube Shorts gibi kısa video platformlarında paylaşmak için idealdir.',
                }
            ]
        },
        modelIntro: {
            title: 'Yaratıcılığınızı serbest bırakın, sihirli dans videoları oluşturmak için WeryAI kullanmaya başlayın',
            description: 'Yapay Zeka Dans Videosu Üreticimizi deneyin',
            buttonText: 'WeryAI Dans Videosu Üreticisini Ücretsiz Deneyin',
            footerText: 'Kredi kartı gerekmez'
        },
        pageTitle: 'Yapay Zeka Dans Videosu Üreticisi - Ücretsiz AI Dans Videosu Oluşturucu | WeryAI',
        pageDescription: 'Fotoğraflardan harika dans videoları oluşturmak için WeryAI Yapay Zeka Dans Videosu Üreticisini kullanın. Birden fazla şablonu ve tarzı destekler, fotoğraflarınıza hayat verin!',
        pageKeywords: 'Yapay zeka dans videosu, yapay zeka dans üreticisi, fotoğraftan videoya, yapay zeka video üretimi, WeryAI, ücretsiz yapay zeka araçları',
    },
};
